import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BEError } from '@classes/BEError.class';
import { CustomHeaders } from '@enums/CustomHeaders.enum';
import { SessionStorageKey } from '@enums/SessionStorageKey.enum';
import { TransformerRequestCodes } from '@enums/TransformerRequestCodes.enum';
import { TransformerResponseCodes } from '@enums/TransformerResponseCodes.enum';
import {
  KTResponse,
  KTResponseCustom,
  KTResponseD,
  KTResponseDNoResult,
  KTResponseNoMessage,
} from '@interfaces/Generic/KTResponse.interface';
import { SetPaymentRequestParams } from '@interfaces/Groups/SetPaymentRequestParams.interface';
import { B2BLoyaltyProgramResponse } from '@interfaces/Jakala/B2BLoyaltyProgramResponse.interface';
import { CitySearchResponse } from '@interfaces/Jakala/CitySearch.interface';
import { CitySuggestionsData } from '@interfaces/Jakala/CitySuggestionsData.interface';
import { AbilitazioneConfig } from '@interfaces/KT/AbilitazioneConfig.interface';
import { AbilitazioneRequestDTO } from '@interfaces/KT/AbilitazioneRequest.interface';
import { AgeRangeDTO } from '@interfaces/KT/AgeRange.interface';
import { AgencyBalanceDataDTO } from '@interfaces/KT/AgencyBalanceData.interface';
import { AgencyProfileDTO } from '@interfaces/KT/AgencyProfile.interface';
import { AgencyProfileResponseDataDTO } from '@interfaces/KT/AgencyProfileResponseData.interface';
import { AgentInvoiceDownloadDTO } from '@interfaces/KT/AgentInvoiceDownload.interface';
import { AirportListDataDTO } from '@interfaces/KT/AirportListData.interface';
import { AutoItemsCruiseListDataDTO } from '@interfaces/KT/AutoItemsCruiseListData.interface';
import { BankInfoResponseDTO } from '@interfaces/KT/BankInfoResponse.interface';
import { BankTAInfoDTO } from '@interfaces/KT/BankTAInfo.interface';
import { BankTAInfoResponseDTO } from '@interfaces/KT/BankTAInfoData.interface';
import { BookingCancellationPenalty } from '@interfaces/KT/BookingCancellationPenalty.interface';
import { BookingDataDTO } from '@interfaces/KT/BookingData.interface';
import { BookingListByAgencyDTO } from '@interfaces/KT/BookingListByAgency.interface';
import { BookingListItemDTO } from '@interfaces/KT/BookingListItem.interface';
import { BusStationListDataDTO } from '@interfaces/KT/BusStationListData.interface';
import { CRMAgencyProfileDTO, CRMAgencyProfileWrapperDTO } from '@interfaces/KT/CRMAgencyProfile.interface';
import { CabinSelectionDataDTO } from '@interfaces/KT/CabinSelectionData.interface';
import { CategoryListDataDTO } from '@interfaces/KT/CategoryListData.interface';
import {
  CreateNewTokenDTO,
  ForceChangePasswordDTO,
  ForgotPasswordSendMailDTO,
  ForgotPasswordSetPasswordDTO,
  ForgotPasswordSetPasswordResponseDTO,
  SetPasswordDTO
} from '@interfaces/KT/ChangePassword.interface';
import { CheckOutSessionDTO } from '@interfaces/KT/CkeckOutSession.interface';
import { ContactInfos } from '@interfaces/KT/ContactInfos.interface';
import { CorrelatedAgencyDTO } from '@interfaces/KT/CorrelatedAgency.interface';
import { CostaClubInfoDTO } from '@interfaces/KT/CostaClubInfo.interface';
import { CountryDTO } from '@interfaces/KT/Country.interface';
import { CountryISOCodeDTO } from '@interfaces/KT/CountryISOCode.interface';
import { CruiseFinderDataDTO } from '@interfaces/KT/CruiseFinderData.interface';
import { CruiseItineraryDTO } from '@interfaces/KT/CruiseItinerary.interface';
import { CruiseListDataDTO } from '@interfaces/KT/CruiseListData.interface';
import { CustomerVoucherListDTO } from '@interfaces/KT/CustomerVoucherList.interface';
import { CustomerVoucherSearchDTO } from '@interfaces/KT/CustomerVoucherSearch.interface';
import { SimpleDocumentDTO } from '@interfaces/KT/Document.interface';
import { DocumentInfoDTO } from '@interfaces/KT/DocumentInfo.interface';
import { RechargeDTO } from '@interfaces/KT/Epipoli/Recharge.interface';
import { WalletDTO } from '@interfaces/KT/Epipoli/Wallet.interface';
import { ExcursionListDataDTO } from '@interfaces/KT/ExcursionListData.interface';
import { ExcursionPDFItemDTO } from '@interfaces/KT/ExcursionPDFItem.interface';
import { ExcursionPDFLanguageDTO } from '@interfaces/KT/ExcursionPDFLanguage.interface';
import { ExcursionReservationGuestDTO } from '@interfaces/KT/ExcursionReservationGuest.interface';
import { FareDTO } from '@interfaces/KT/Fare.interface';
import { FarePricesCruiseListDataDTO } from '@interfaces/KT/FarePricesCruiseListData.interface';
import { GroupLoadOperationDataDTO } from '@interfaces/KT/GroupLoadOperationData.interface';
import { GroupRequestDTO } from '@interfaces/KT/GroupRequest.interface';
import { GroupResponseDataDTO } from '@interfaces/KT/GroupResponseData.interface';
import { GroupToolDataDTO } from '@interfaces/KT/GroupToolData.interface';
import { HotelListDataDTO } from '@interfaces/KT/HotelListData.interface';
import { InsuranceTypeDTO } from '@interfaces/KT/InsuranceType.interface';
import { LanguageDTO } from '@interfaces/KT/Language.interface';
import { MandatoryTransportationDirectionDTO } from '@interfaces/KT/MandatoryTransportationDirection.interface';
import { MenuItemDTO } from '@interfaces/KT/MenuItem.interface';
import { MessageDTO } from '@interfaces/KT/Message.interface';
import { MortgageDataDTO } from '@interfaces/KT/MortgageData.interface';
import { NationalityDTO } from '@interfaces/KT/Nationality.interface';
import { NewsListDataDTO } from '@interfaces/KT/NewsListData.interface';
import { PaymentDTO } from '@interfaces/KT/Payment.intereface';
import { PreCalculationScoreDTO } from '@interfaces/KT/PreCalculationScore.interface';
import { PreCalculationScoreRequestDTO } from '@interfaces/KT/PreCalculationScoreRequest.interface';
import { PromoGeolocationParams } from '@interfaces/KT/PromoGeolocationParams.interface';
import { PromoTransportationSolutionListDataDTO } from '@interfaces/KT/PromoTransportationSolutionListData.interface';
import { RegionDTO } from '@interfaces/KT/Region.interface';
import { RestaurantListsDTO } from '@interfaces/KT/RestaurantLists.interface';
import { SectionDTO } from '@interfaces/KT/Section.interface';
import { ServiceChargeDTO } from '@interfaces/KT/ServiceCharge.interface';
import { SetPaymentExtendedRequestParams, SetPaymentExtendedResponse } from '@interfaces/KT/SetPaymentExtended.interface';
import { ShipListItemDTO } from '@interfaces/KT/Ship.interface';
import { SpecialServiceListDataDTO } from '@interfaces/KT/SpecialServiceListData.interface';
import { TicketDTO } from '@interfaces/KT/Ticket.interface';
import { TipDTO } from '@interfaces/KT/Tip.interface';
import { UserProfileDTO } from '@interfaces/KT/UserProfile.interface';
import { VoucherDTO } from '@interfaces/KT/Voucher.interface';
import { ActualDetailData } from '@interfaces/KT/WeCare/ActualDetailData.interface';
import { JumpData } from '@interfaces/KT/WeCare/JumpData.interface';
import { SeguiCData } from '@interfaces/KT/WeCare/SeguiCData.interface';
import { WeCareAgencyData } from '@interfaces/KT/WeCare/WeCareAgencyData.interface';
import { WeCareDataDTO } from '@interfaces/KT/WeCare/WeCareData.interface';
import dayjs from 'dayjs';
import { Observable, catchError, debounceTime, delay, finalize, lastValueFrom, map, of, tap } from 'rxjs';
import { LoadingService } from './loading.service';
import { MarketService } from './market.service';
//import {airResponseMock} from "@services/mocks/AirRTMock2";

@Injectable({
  providedIn: 'root',
})
export class CostaBackendApiService {
  private readonly _http = inject(HttpClient);
  private readonly _loadingService = inject(LoadingService);
  private readonly _marketService = inject(MarketService);

  private readonly BookingFlowServicesPath = '_vti_bin/CostaClickNew/UIServices/BookingFlowServices.svc/';
  private readonly UserServicesPath = '_vti_bin/CostaClickNew/UIServices/UserServices.svc/';
  private readonly GenericServicesPath = '_vti_bin/CostaClickNew/UIServices/GenericServices.svc/';
  private readonly ContentServicesPath = '_vti_bin/CostaClickNew/UIServices/ContentServices.svc/';
  private readonly ExcursionServicesPath = '_vti_bin/CostaClickNew/UIServices/ExcursionServices.svc/';
  private readonly EpipoliServicesPath = '_vti_bin/CostaClickNew/UIServices/EpipoliServices.svc/';
  private readonly WeCareServicesPath = '../Templates/AgencyBalance/WeCare.aspx/';
  private readonly HandlersPath = '/_layouts/15/CostaClickNew/HttpHandlers/';

  private get CCKBasePath() {
    return window?.cckBasePath;
  }

  private readonly OcpPro = '160e607816cf40cda7745d0e960852ec';
  private readonly JakalaLegacyHeaders = new HttpHeaders({ 'Ocp-Apim-Subscription-Key': this.OcpPro });
  private readonly JakalaHeaders = new HttpHeaders({ 'Jakala-Subscription-Key': this.OcpPro });
  private readonly WithCredentials = {
    withCredentials: true,
  };
  private readonly UPLOAD = {
    withCredentials: true,
  };

  private handleKtApi<T>(source$: Observable<KTResponse<T>>): Observable<T> {
    return source$.pipe(
      tap((res) => {
        if (!res?.d?.Success) throw res;
      }),
      map((res) => res?.d.Result),
      catchError((res) => {
        console.error('Rejected async call.', res);
        throw new BEError(res);
      }),
    );
  }

  private handleKtApiWithNoMessage<T extends object>(source$: Observable<KTResponseNoMessage<T>>): Observable<KTResponseNoMessage<T>['d']> {
    return source$.pipe(
      tap((res) => {
        if (!res?.d) throw null;
      }),
      map((res) => res?.d),
      catchError((res) => {
        console.error('Rejected async call.', res);
        throw new BEError(res);
      }),
    );
  }

  private handleKtApiWithBlockingMessage<T>(source$: Observable<KTResponse<T>>): Observable<T> {
    return source$.pipe(
      tap((res) => {
        if (!res?.d?.Success || res?.d?.Message) throw res;
      }),
      map((res) => res?.d?.Result),
      catchError((res) => {
        console.error('Rejected async call.', res);
        throw new BEError(res);
      }),
    );
  }

  private handleKtApiWithWarningMessage<T extends KTResponseDNoResult>(
    source$: Observable<KTResponseCustom<T>>,
  ): Observable<KTResponseCustom<T>['d']> {
    return source$.pipe(
      tap((res) => {
        if (!res?.d?.Success) throw res;
      }),
      map((res) => res?.d),
      catchError((res) => {
        console.error('Rejected async call.', res);
        throw new BEError(res);
      }),
    );
  }

  private mockApi<T>(data: T, delayMilliseconds = 1000): Observable<T> {
    return of(data).pipe(delay(delayMilliseconds));
  }

  private handleApi<T>(source$: Observable<T>): Observable<T> {
    return source$.pipe(
      tap((res) => {
        if (!res) throw 'Unexpected Error';
      }),
      map((res) => res),
      catchError((res) => {
        console.error('Rejected async call.', res);
        throw new Error(res);
      }),
    );
  }

  /**
   * Fornisce gli elenchi di destinazioni e tariffe con cui riempire le relative liste a partire dalle date selezionate.
   *
   * @param inFrom Search From
   * @param inTo Search To
   * @param inDestination Search in destinations selected
   * @param inFare Search in fares selected
   * @see prefetchExtended
   * @deprecated
   */
  public prefetch(inFrom: Date, inTo: Date, inDestination: string[] = [], inFare: string[] = []): Promise<any> {
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetCruiseFinderData`;
    const obs$ = this._http
      .post<KTResponse<any>>(
        api,
        {
          inFrom,
          inTo,
          inDestination,
          inFare,
        },
        this.WithCredentials,
      )
      .pipe(this.handleKtApi);
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce gli elenchi di destinazioni, navi, porti e tariffe con cui riempire
   * le relative liste a partire dalle date selezionate e da eventuali altri
   * criteri di ricerca.
   *
   * @param inFrom Search From
   * @param inTo Search To
   * @param inDestination Search in destinations selected
   * @param inFare Search in fares selected
   * @param inPort Search in ports selected
   * @param inShip Search in ships selected
   * @param inDiscount Search in discounts selected
   * @param inOccupancy Search in occupancies selected
   *
   * @returns {Promise<CruiseFinderDataDTO>}
   */
  public prefetchExtended(
    inFrom: Date,
    inTo: Date,
    inDestination: string[] = [],
    inFare: string[] = [],
    inPort: string[] = [],
    inShip: string[] = [],
    inDiscount: string[] = [],
    inOccupancy: string[] = [],
  ): Promise<CruiseFinderDataDTO> {
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetExtendedCruiseFinderData`;
    const obs$ = this._http
      .post<KTResponse<CruiseFinderDataDTO>>(
        api,
        {
          filters: {
            from: dayjs(inFrom).format('YYYY-MM-DD'),
            to: dayjs(inTo).format('YYYY-MM-DD'),
            destinationCode: inDestination.join(','),
            fareCode: inFare.join(','),
            portCode: inPort.join(','),
            shipCode: inShip.join(','),
            discountCode: inDiscount.join(','),
            occupancyCode: inOccupancy.join(','),
          },
        },
        this.WithCredentials,
      )
      .pipe(debounceTime(250), this.handleKtApi);

    return lastValueFrom(obs$);
  }

  /**
   * Permette di effettuare l'upload del file CSV per il group load.
   *
   * @param file File to upload
   * @returns {Promise<KTResponseD<string>>}
   */
  public uploadGroupLoadData(file: File): Promise<KTResponseD<string>> {
    const loader = 'uploadGroupLoadData';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}UploadGroupLoadData`;
    const formData = new FormData();
    formData.append('file', file);
    const obs$ = this._http.post<KTResponse<string>>(api, formData, this.UPLOAD).pipe(
      this.handleKtApiWithWarningMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }

  /**
   * Restituisce le operazioni di Group Load salvate su database.
   *
   * @param groupId Id Grouppo da richiedere
   * @param timeInterval Intervallo di tempo
   * @returns {Promise<GroupLoadOperationDataDTO>}
   */
  public getGroupLoadOperations(groupId = '', timeInterval: 'Today' | 'ThisMonth' | '' = ''): Promise<GroupLoadOperationDataDTO> {
    const loader = 'getGroupLoadOperations';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetGroupLoadOperations`;
    const obs$ = this._http
      .post<KTResponse<GroupLoadOperationDataDTO>>(
        api,
        {
          groupId,
          timeInterval,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );

    return lastValueFrom(obs$);
  }

  /**
   * Restituisce i dettagli dell'operazione di Group Load specificata.
   *
   * @param operationId OperationId da richiedere
   * @returns {Promise<GroupLoadOperationDataDTO>}
   */
  public getGroupLoadOperationDetails(operationId: string): Promise<GroupLoadOperationDataDTO> {
    const loader = 'getGroupLoadOperationDetails';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetGroupLoadOperationDetails`;
    const obs$ = this._http
      .post<KTResponse<GroupLoadOperationDataDTO>>(
        api,
        {
          operationId,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );

    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'URL del file CSV contenente i dettagli dell'operazione di Group Load specificata.
   *
   * @param operationId OperationId da richiedere
   * @returns {Promise<string>}
   */
  public getGroupLoadOperationDetailsCsv(operationId: string): Promise<string> {
    const loader = 'getGroupLoadOperationDetailsCsv';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetGroupLoadOperationDetailsCsv`;
    const obs$ = this._http
      .post<KTResponse<string>>(
        api,
        {
          operationId,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );

    return lastValueFrom(obs$);
  }

  /**
   * Richiede di posticipare la data di scadenza dell'opzione sulla pratica attualmente in sessione.
   * Il metodo può essere chiamato se la sezione OptionDate delle allowed operation del booking ha
   * l'operazione Modify abilitata.
   *
   * @returns {KTResponseD<boolean>}
   */
  public extendOptionDate(): Promise<KTResponseD<boolean>> {
    const loader = 'extendOptionDate';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}ExtendOptionDate`;
    const obs$ = this._http.post<KTResponse<boolean>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithWarningMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }


  /**
   * Richiede di posticipare la data di scadenza dell’opzione sulla pratica richiesta in input.
   *
   * @returns {KTResponseD<boolean>}
   */
  public extendOptionDateForBooking(bookingNumber : string): Promise<KTResponseD<boolean>> {
    const loader = 'extendOptionDateForBooking';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}ExtendOptionDateForBooking`;
    const obs$ = this._http.post<KTResponse<boolean>>(api, { bookingNumber }, this.WithCredentials).pipe(
      this.handleKtApiWithWarningMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }

  /**
   * Permette di annullare il booking in sessione.
   *
   * @param penaltyInfo Risposta della chiamata GetBookingCancellationPenalty
   * @see retrieveBookingCancellationPenalty
   * @returns {Promise<null>}
   */
  public cancelBooking(penaltyInfo: BookingCancellationPenalty = undefined): Promise<null> {
    const loader = 'cancelBooking';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}CancelBooking`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          penaltyInfo,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di conoscere la penale in caso di annullamento del booking in sessione.
   * Se il booking non è in stato BKD la penale è nulla.
   *
   * @returns {Promise<BookingCancellationPenalty>}
   */
  public retrieveBookingCancellationPenalty(): Promise<BookingCancellationPenalty> {
    const loader = 'retrieveBookingCancellationPenalty';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetBookingCancellationPenalty`;
    const obs$ = this._http.post<KTResponse<BookingCancellationPenalty>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Effettua la login di un utente dati Username e Password.
   * Se la login ha esito positivo verranno rilasciati una serie di cookie che saranno poi usati dall'applicativo,
   * tutte le chiamate successive dovranno quindi provvedere ad inviare i suddetti cookie.
   * Il servizio può essere chiamato in anonimo.
   *
   * @param username Username utente
   * @param password Password utente
   * @returns {Promise<string>}
   */
  public login(username: string, password: string): Promise<string> {
    const loader = 'login';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}LoginUser`;
    const obs$ = this._http
      .post<KTResponse<string>>(
        api,
        {
          loginInfo: {
            UserName: username,
            Password: password,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna le informazioni di contatto.
   *
   * @returns {Promise<ContactInfos>}
   */
  public getContactInfos(): Promise<ContactInfos> {
    const loader = 'getContactInfos';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetContactInfos`;
    const obs$ = this._http.post<KTResponse<ContactInfos>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce gli elenchi di destinazioni e tariffe con cui riempire le relative liste a partire dalle date selezionate.
   *
   * @param inFrom Ricerca da
   * @param inTo Ricerca a
   * @param inDestination Destinazioni
   * @param inFare Tariffe
   * @param inOccupancy Occupancy
   * @returns {Promise<CruiseListDataDTO>}
   */
  public cruiseSearch(
    inFrom: Date,
    inTo: Date,
    inDestination: string[] = [],
    inFare: string[] = [],
    inOccupancy: string[] = [],
  ): Promise<CruiseListDataDTO> {
    const loader = 'cruiseSearch';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetCruiseListData`;
    const obs$ = this._http
      .post<KTResponse<CruiseListDataDTO>>(
        api,
        {
          from: dayjs(inFrom).format('YYYY-MM-DD'),
          to: dayjs(inTo).format('YYYY-MM-DD'),
          destinationCode: inDestination.join(','),
          fareCode: inFare.join(','),
          occupancyCode: inOccupancy.join(','),
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce la lista delle crociere in base ai parametri di ricerca specificati. \
   * **NON** torna informazioni relative ai prezzi se useLightSearch è passato a *true*
   *
   * @param inFrom Ricerca da
   * @param inTo Ricerca a
   * @param inDestination Destinazioni
   * @param inFare Tariffe
   * @param inOccupancy Occupancies
   * @param inPort Porti
   * @param inShip Navi
   * @param inDiscount Sconti
   * @param useLightSearch Utilizza ricerca light?
   * @returns {Promise<CruiseListDataDTO>}
   */
  public cruiseExtendedSearch(
    inFrom: Date,
    inTo: Date,
    inDestination: string[] = [],
    inFare: string[] = [],
    inOccupancy: string[] = [],
    inPort: string[] = [],
    inShip: string[] = [],
    inDiscount: string[] = [],
    useLightSearch = false,
  ): Promise<CruiseListDataDTO> {
    const loader = 'cruiseExtendedSearch';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetExtendedCruiseListData`;
    const apiLight = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetCruiseList`;
    const obs$ = this._http
      .post<KTResponse<CruiseListDataDTO>>(
        useLightSearch ? apiLight : api,
        {
          filters: {
            from: dayjs(inFrom).format('YYYY-MM-DD'),
            to: dayjs(inTo).format('YYYY-MM-DD'),
            destinationCode: inDestination.join(','),
            fareCode: inFare.join(','),
            portCode: inPort.join(','),
            shipCode: inShip.join(','),
            discountCode: inDiscount.join(','),
            occupancyCode: inOccupancy.join(','),
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di effettuare una richiesta di gruppo.
   *
   * @param GroupId Id Gruppo
   * @param ShipName Nome nave
   * @param DepartureDate Data di partenza
   * @param DeparturePort Porto di partenza
   * @param NumberOfGuests Numero di passeggeri
   * @param NumberOfCabins Numero di cabine
   * @param CabinType Tipologia cabine
   * @param GroupType Tipologia gruppo
   * @param NumberOfBeds Numero di letti
   * @param NumberOfSingleCabins Numero di cabine singole
   * @param DepartureAirport Porto di partenza
   * @param Notes Note
   * @param ContactName Nome contatto
   * @param ContactPhoneNumber Telefono contatto
   * @param ContactEmail Email contatto
   * @returns {Promise<GroupRequestDTO>}
   */
  public getGroupRequest(
    GroupId: string,
    ShipName: string,
    DepartureDate: string,
    DeparturePort: string,
    NumberOfGuests: string,
    NumberOfCabins: string,
    CabinType: string,
    GroupType: string,
    NumberOfBeds: string,
    NumberOfSingleCabins: string,
    DepartureAirport: string,
    Notes: string,
    ContactName: string,
    ContactPhoneNumber: string,
    ContactEmail: string,
  ): Promise<GroupRequestDTO> {
    const loader = 'getGroupRequest';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GroupRequest`;
    const obs$ = this._http
      .post<KTResponse<any>>(
        api,
        {
          request: {
            GroupId,
            ShipName,
            DepartureDate,
            DeparturePort,
            NumberOfGuests,
            NumberOfCabins,
            CabinType,
            GroupType,
            NumberOfBeds,
            NumberOfSingleCabins,
            DepartureAirport,
            Notes,
            ContactName,
            ContactPhoneNumber,
            ContactEmail,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di impostare i dati strettamente necessari per la creazione in memoria
   * di un oggetto Booking, che sarà restituito come output.
   *
   * @param firstCruiseCode Codice Crociera
   * @param fareCode Codice Tariffa
   * @param categoryCode Codice Categoria
   * @param occupancyCode Codice Occupazione
   * @param secondCruiseCode Codice Crociera 2
   * @returns {Promise<BookingDataDTO>}
   */
  public initialiseBooking(
    firstCruiseCode: string,
    fareCode: string,
    categoryCode: string,
    occupancyCode: string,
    secondCruiseCode = '',
  ): Promise<BookingDataDTO> {
    const loader = 'initialiseBooking';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}InitializeBooking`;
    const obs$ = this._http
      .post<KTResponse<BookingDataDTO>>(
        api,
        {
          firstCruiseCode,
          secondCruiseCode,
          fareCode,
          categoryCode,
          occupancyCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di richiedere la fattura per il gruppo specificato.
   *
   * @param groupId Id gruppo
   * @param firstEmail Email 1
   * @param secondEmail Email 2
   * @param eventsFlag Flag Eventi
   * @param transportationInfoFlag Flag Trasporti
   * @param allFlag Flag Tutti
   * @param paxDetailsFlag Flag Passeggeri
   * @param groupMasterChargesFlag Flag master charges
   * @param detailSummaryFlag Flag dettaglio
   * @param groupPaymentFlag Flag pagamento
   * @param allocationSummaryFlag Flag allocazione
   * @param printMode Flag stampa
   * @returns {Promise<null>}
   */
  public getGroupInvoice(
    groupId: string,
    firstEmail: string,
    secondEmail: string,
    eventsFlag = false,
    transportationInfoFlag = false,
    allFlag = false,
    paxDetailsFlag = false,
    groupMasterChargesFlag = false,
    detailSummaryFlag = false,
    groupPaymentFlag = false,
    allocationSummaryFlag = false,
    printMode = 2,
  ): Promise<null> {
    const loader = 'getGroupInvoice';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GroupInvoice`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          request: {
            GroupId: groupId,
            FirstEmail: firstEmail,
            SecondEmail: secondEmail,
            Events: eventsFlag,
            TransportationInfo: transportationInfoFlag,
            Print: printMode,
            Sections: {
              All: allFlag,
              PaxDetails: paxDetailsFlag,
              GroupMasterCharges: groupMasterChargesFlag,
              DetailSummary: detailSummaryFlag,
              GroupPayment: groupPaymentFlag,
              AllocationSummary: allocationSummaryFlag,
            },
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce le soglie di età in base alla config del booking correte.
   *
   * @returns {Promise<AgeRangeDTO>}
   */
  public getAgeRange(): Promise<AgeRangeDTO> {
    const loader = 'getAgeRange';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAgeRange`;
    const obs$ = this._http.post<KTResponse<AgeRangeDTO>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Gestisce l'invio della lettera di conferma per email o fax.
   * In caso di compilazione di entrambi i valori prevale l'email
   *
   * @param emailAddress Email
   * @param versionType AGENCY or GUEST
   * @returns {Promise<null>}
   */
  public sendConfirmationLetter(emailAddress: string, versionType: string): Promise<null> {
    const loader = 'sendConfirmationLetter';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}SendConfirmationLetter`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          emailAddress,
          versionType,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Effettua una quotazione sulla base dei dati selezionati. Nel booking deve essere presente una sola cabina.
   * Non è previsto alcun parametro di input, ma occorre chiamare preventivamente setCurrentBookingToSession
   *
   * @see setCurrentBookingToSession.
   * @returns {Promise<BookingDataDTO>}
   */
  public quickQuotation(): Promise<BookingDataDTO> {
    const loader = 'quickQuotation';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}QuickQuotation`;
    const obs$ = this._http.post<KTResponse<BookingDataDTO>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna le informazioni necessarie a compilare la modale di dettaglio itinerario
   *
   * @param cruiseCode Codice Crociera
   * @returns {Promise<CruiseItineraryDTO>}
   */
  public GetItineraryDetails(cruiseCode: string): Promise<CruiseItineraryDTO> {
    const loader = 'GetItineraryDetails';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetItineraryDetails`;

    const obs$ = this._http
      .post<KTResponse<CruiseItineraryDTO>>(
        api,
        {
          cruiseCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );

     return lastValueFrom(obs$);
  }

  /**
   * Permette di modificare la tariffa del booking in sessione, effettuando il preventivo se richiesto.
   * L'elenco delle possibili tariffe viene restituito dal metodo GetFares.
   * Il metodo può essere chiamato se la property CanChangeFare del booking è uguale a true.
   * Se la modifica della tariffa va a buon fine occorre chiamare DisplayBooking per avere i dati aggiornati.
   *
   * @param isQuotation Se si vuole ottenere un preventivo o se si vuole cambiare la tariffa
   * @param fareCode Codice Tariffa
   * @param costaClubInfo Dati C|Club
   * @see getFares;
   * @see displayBooking;
   * @returns
   */
  public changeFare(isQuotation: boolean, fareCode: string, costaClubInfo: CostaClubInfoDTO): Promise<any> {
    const loader = 'changeFare';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}ChangeFare`;
    const obs$ = this._http
      .post<KTResponse<any>>(
        api,
        {
          quote: isQuotation,
          fareCode,
          costaClubInfo,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce le informazioni CostaClub per il passeggero specificato. \
   * E' indispensabile specificare LastName e CostaClubNumber, oppure FirstName, LastName e BirthDate. \
   * Se tutti i campi sono compilati, la priorità è data a CostaClubNumber
   *
   * @param FirstName Nome
   * @param LastName  Cognome
   * @param CostaClubNumber  Codice carla C|Club
   * @param birthDate  Data di nascita
   * @returns {Promise<CostaClubInfoDTO>}
   */
  public getCostaClubInfo(FirstName: string, LastName: string, CostaClubNumber: string, birthDate: string = null): Promise<any> {
    const loader = 'getCostaClubInfo';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetCostaClubInfo`;
    const obs$ = this._http
      .post<KTResponse<any>>(
        api,
        {
          request: {
            FirstName,
            LastName,
            CostaClubNumber,
            BirthDate: birthDate ? dayjs(birthDate).format('YYYY-MM-DD') : '',
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce il dettaglio delle operazioni consentite e delle configurazioni in
   * base alle configurazioni di sistema ed al booking attualmente salvato in sessione
   *
   * @returns {Promise<SectionDTO[]>}
   */
  public GetAllowedOperationForBooking(): Promise<SectionDTO[]> {
    const loader = 'GetAllowedOperationForBooking';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAllowedOperationForBooking`;
    const obs$ = this._http.post<KTResponse<SectionDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce il dettaglio delle operazioni consentite e delle configurazioni in
   * base alle configurazioni di sistema ed al booking attualmente salvato in sessione
   *
   * @returns {Promise<SectionDTO[]>}
   */
  public GetAllowedOperationForGuest(guestId: any): Promise<any> {
    const loader = 'GetAllowedOperationForGuest';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAllowedOperationForGuest`;
    const obs$ = this._http
      .post<KTResponse<any>>(
        api,
        {
          guestId,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce un elenco di Massage e Warining da in base all'attuale configurazione del booking in sessione
   *
   * @returns {Promise<MessageDTO[]>}
   */
  public GetBookingWarningsAndMessages(): Promise<MessageDTO[]> {
    const loader = 'GetBookingWarningsAndMessages';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetBookingWarningsAndMessages`;
    const obs$ = this._http.post<KTResponse<MessageDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce un elenco di Tips (messaggi) da visualizzare in base all'attuale configurazione del booking in sessione.
   * A differenza dei message and warning questi possono richiedere la visualizzazione in modale/popup e
   * l'interazione dell'utente (checkbox) per permettere di chiudere la popup/modale e proseguire nella navigazione
   *
   * @returns {Promise<TipDTO[]>}
   */
  public GetBookingTips(): Promise<TipDTO[]> {
    const loader = 'GetBookingTips';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetBookingTips`;
    const obs$ = this._http.post<KTResponse<TipDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle tariffe disponibili per la crociera precedentemente selezionata.
   * Se in sessione c'è un numero di booking vengono restituiti i valori che si possono scegliere allo step 5 per il cambio tariffa.
   *
   * @returns {Promise<FareDTO[]>}
   */
  public getFares(): Promise<FareDTO[]> {
    const loader = 'getFares';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetFares`;
    const obs$ = this._http.post<KTResponse<FareDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Occorre chiamare questo metodo ogniqualvolta si selezioni una tariffa differente
   * dalla dropdown dello step CategorySelection, o si cambi il valore della checkbox
   * CostaClub oppure si specifichi un diverso group ID.
   *
   * @param fareObj Fare
   * @returns {Promise<{}>}
   */
  public setFares(fare: FareDTO): Promise<Record<string, unknown>> {
    const loader = 'setFares';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}SetFare`;
    const obs$ = this._http
      .post<KTResponse<Record<string, unknown>>>(
        api,
        {
          fare,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei voli di linea disponibili a catalogo, con le relative direzioni e classi di volo ammesse.
   *
   * @returns {Promise<AirportListDataDTO>}
   */
  public getAirports(): Promise<AirportListDataDTO> {
    const loader = 'getAirports';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAirports`;
    const obs$ = this._http.post<KTResponse<AirportListDataDTO>>(api, {}, this.WithCredentials).pipe(
     this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);


    // return lastValueFrom(this.mockApi(airResponseMock));
  }

  /**
   * Verifica se ci sono voli promo disponibili.
   *
   * @returns {Promise<boolean>}
   */
  public checkPromoFlightAvailability(): Promise<boolean> {
    const loader = 'checkPromoFlightAvailability';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}CheckPromoFlightAvailability`;
    const obs$ = this._http
      .post<KTResponse<boolean>>(
        api,
        {
          flightClass: '',
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApiWithBlockingMessage,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Verifica se ci sono bus promo disponibili.
   *
   * @returns {Promise<boolean>}
   */
  public checkPromoBusAvailability(): Promise<boolean> {
    const loader = 'checkPromoBusAvailability';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}CheckPromoBusAvailability`;
    const obs$ = this._http.post<KTResponse<boolean>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithBlockingMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Verifica se ci sono trasporti generici promo disponibili.
   *
   * @returns {Promise<boolean>}
   */
  public checkPromoGenericTransportationAvailability(): Promise<boolean> {
    const loader = 'checkPromoGenericTransportationAvailability';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}CheckPromoGenericTransportationAvailability`;
    const obs$ = this._http.post<KTResponse<boolean>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithBlockingMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei voli promo disponibili.
   *
   * @returns {Promise<AirportListDataDTO>}
   */
  public getPromoAirports(): Promise<AirportListDataDTO> {
    const loader = 'getPromoAirports';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetPromoAirports`;
    const obs$ = this._http
      .post<KTResponse<AirportListDataDTO>>(
        api,
        {
          flightClass: '',
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApiWithBlockingMessage,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle soluzioni di volo promozionali disponibili.
   *
   * @param parameters Geolocation params
   * @returns {Promise<PromoTransportationSolutionListDataDTO>}
   */
  public getPromoFlightSolutions(parameters: PromoGeolocationParams): Promise<PromoTransportationSolutionListDataDTO> {
    const loader = 'getPromoFlightSolutions';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetPromoFlightSolutions`;
    const obs$ = this._http
      .post<KTResponse<PromoTransportationSolutionListDataDTO>>(
        api,
        {
          ...parameters,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle soluzioni di volo promozionali disponibili.
   *
   * @param parameters Geolocation params
   * @returns {Promise<PromoTransportationSolutionListDataDTO>}
   */
  public GetPromoGenericTransportationSolutions(parameters: PromoGeolocationParams): Promise<PromoTransportationSolutionListDataDTO> {
    const loader = 'GetPromoGenericTransportationSolutions';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetPromoGenericTransportationSolutions`;
    const obs$ = this._http
      .post<KTResponse<PromoTransportationSolutionListDataDTO>>(
        api,
        {
          ...parameters,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle soluzioni di volo promozionali disponibili.
   *
   * @param parameters Geolocation params
   * @returns {Promise<PromoTransportationSolutionListDataDTO>}
   */
  public GetPromoBusSolutions(parameters: any): Promise<any> {
    const loader = 'GetPromoBusSolutions';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetPromoBusSolutions`;
    const obs$ = this._http
      .post<KTResponse<any>>(
        api,
        {
          ...parameters,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle stazioni per cui sono disponibili collegamenti mediante autobus
   *
   * @param direction
   * @returns {Promise<BusStationListDataDTO>}
   */
  public getBusStations(direction: 'InBound' | 'OutBound' | 'Both' | 'Any'): Promise<BusStationListDataDTO> {
    const loader = 'getBusStations';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetBusStations`;
    const obs$ = this._http
      .post<KTResponse<BusStationListDataDTO>>(
        api,
        {
          direction,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco degli hotel disponibili.
   *
   * @param cabinIndex Indice della cabina da richiedere
   * @returns {Promise<HotelListDataDTO>}
   */
  public getHotels(cabinIndex: number = undefined): Promise<HotelListDataDTO> {
    const loader = 'getHotels';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetHotels`;
    const obs$ = this._http
      .post<KTResponse<HotelListDataDTO>>(
        api,
        {
          cabinIndex,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle categorie disponibili per la cabina specificata.
   *
   * @param cabinIndex: Indice Cabina da richiedere
   * @returns  {Promise<CategoryListDataDTO>}
   */
  public getAvailableCategories(cabinIndex: number): Promise<CategoryListDataDTO> {
    const loader = 'getAvailableCategories';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAvailableCategories`;
    const obs$ = this._http
      .post<KTResponse<CategoryListDataDTO>>(
        api,
        {
          cabinIndex,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce per ciascuna cabina del booking l'elenco delle cabine disponibili.
   *
   * @param cabinIndex
   * @param categoryCodes
   * @returns {Promise<CabinSelectionDataDTO>}
   */
  public getAvailableCabins_Legacy(cabinIndex: number, categoryCodes: [string?] = []): Promise<CabinSelectionDataDTO> {
    const loader = 'getAvailableCabins';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAvailableCabinsByCategoryCodes`;
    const obs$ = this._http
      .post<KTResponse<CabinSelectionDataDTO>>(
        api,
        {
          cabinIndex,
          categoryCodes
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  public getAvailableCabins(cabinIndex: number, categoryCodes : [string?] = [], getFamilyPlan: boolean = false): Promise<CabinSelectionDataDTO> {
    const loader = 'GetAvailableCabinsByCategoryCodes';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAvailableCabinsByCategoryCodes`;

    let req: {cabinIndex: number, categoryCodes: [string?], getFamilyPlan?: boolean} = { cabinIndex, categoryCodes };
    if(this._marketService.hasNewFamilyPlan()){
      req = { cabinIndex, categoryCodes, getFamilyPlan }
    }

    const obs$ = this._http
      .post<KTResponse<CabinSelectionDataDTO>>(
        api,
        req,
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Richiede una quotazione completa sulla base dei dati selezionati.
   *
   * @param Booking Booking
   * @returns
   */
  public getQuotation(Booking: BookingDataDTO): Promise<BookingDataDTO> {
    const loader = 'getQuotation';
    this._loadingService.startLoading(loader);
    let headers = new HttpHeaders();
    headers = headers.append(
      CustomHeaders.TRANSFORM_REQUEST,
      [TransformerRequestCodes.REMOVE_AUTO_SSV, TransformerRequestCodes.ADD_FISCOD_FOREIGN_GUEST].join(','),
    );
    headers = headers.append(
      CustomHeaders.TRANSFORM_RESPONSE,
      [TransformerResponseCodes.REMOVE_FISCOD_ON_FOREIGN_GUEST, TransformerResponseCodes.GUEST_TBA].join(','),
    );
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetQuotation`;
    const obs$ = this._http
      .post<KTResponse<BookingDataDTO>>(
        api,
        {
          request: {
            Booking,
          },
        },
        {
          ...this.WithCredentials,
          headers,
        },
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Richiede la creazione di una pratica sulla base dei dati selezionati
   *
   * @param Booking
   * @returns {Promise<BookingDataDTO>}
   */
  public createBooking(Booking: BookingDataDTO): Promise<BookingDataDTO> {
    const loader = 'createBooking';
    this._loadingService.startLoading(loader);
    let headers = new HttpHeaders();
    headers = headers.append(CustomHeaders.TRANSFORM_REQUEST, [TransformerRequestCodes.ADD_FISCOD_FOREIGN_GUEST].join(','));
    headers = headers.append(CustomHeaders.TRANSFORM_RESPONSE, [TransformerResponseCodes.REMOVE_FISCOD_ON_FOREIGN_GUEST].join(','));
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}CreateBooking`;
    const obs$ = this._http
      .post<KTResponse<BookingDataDTO>>(
        api,
        {
          request: {
            Booking,
          },
        },
        {
          ...this.WithCredentials,
          headers,
        },
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Consente di modificare i dati di una pratica precedentemente creata. \
   * Questo metodo va chiamato ad ogni modifica della pratica
   *
   * @example aggiunta o modifica di cabine, passeggeri, voli, servizi speciali etc...
   * @param Booking
   * @param Payment
   * @returns {Promise<KTResponseD<BookingDataDTO>>}
   */
  public modifyBooking(Booking: BookingDataDTO, Payment: Partial<PaymentDTO> = undefined): Promise<KTResponseD<BookingDataDTO>> {
    const loader = 'modifyBooking';
    this._loadingService.startLoading(loader);
    let headers = new HttpHeaders();
    headers = headers.append(
      CustomHeaders.TRANSFORM_REQUEST,
      [
        TransformerRequestCodes.REMOVE_AUTO_SSV,
        TransformerRequestCodes.REMOVE_EMPTY_WEB_CHECKIN,
        TransformerRequestCodes.ADD_FISCOD_FOREIGN_GUEST,
      ].join(','),
    );
    headers = headers.append(
      CustomHeaders.TRANSFORM_RESPONSE,
      [TransformerResponseCodes.REMOVE_FISCOD_ON_FOREIGN_GUEST, TransformerResponseCodes.GUEST_TBA].join(','),
    );
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}ModifyBooking`;
    const obs$ = this._http
      .post<KTResponse<BookingDataDTO>>(
        api,
        {
          request: {
            Booking,
            Payment,
          },
        },
        {
          ...this.WithCredentials,
          headers,
        },
      )
      .pipe(
        this.handleKtApiWithWarningMessage,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di ottenere l'url della lista di document legati al viaggio.
   *
   * @returns {Promise<string>}
   */
  public GetErpIdListUrl(): Promise<string> {
    const loader = 'GetErpIdListUrl';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetErpIdListUrl`;
    const obs$ = this._http.post<KTResponse<string>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Consente di confermare una pratica precedentemente creata.
   *
   * @param Booking
   * @returns {Promise<KTResponseD<BookingDataDTO>>}
   */
  public confirmBooking(Booking: BookingDataDTO): Promise<KTResponseD<BookingDataDTO>> {
    const loader = 'confirmBooking';
    this._loadingService.startLoading(loader);
    let headers = new HttpHeaders();
    headers = headers.append(CustomHeaders.TRANSFORM_REQUEST, [TransformerRequestCodes.ADD_FISCOD_FOREIGN_GUEST].join(','));
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}ConfirmBooking`;
    const obs$ = this._http
      .post<KTResponse<BookingDataDTO>>(
        api,
        {
          request: {
            Booking,
          },
        },
        {
          ...this.WithCredentials,
          headers,
        },
      )
      .pipe(
        this.handleKtApiWithWarningMessage,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Controlla se il voucher è disponibile per il passeggero specificato.
   *
   * @param guestId Id Guest
   * @param voucherId Id Voucher
   * @returns {Promise<KTResponse<VoucherDTO[]>>}
   */
  public checkVoucher(guestId: string, voucherId: string): Promise<VoucherDTO[]> {
    const loader = 'checkVoucher';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}CheckVoucher`;
    const obs$ = this._http
      .post<KTResponse<VoucherDTO[]>>(
        api,
        {
          guestId,
          voucherId,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna i parametri necessari per effettuare la chiamata di richiesta abilitazione. \
   * Tale chiamata ha infatti funzionalità e specifiche diverse a seconda del mercato. \
   * Il servizio può essere chiamato in anonimo
   *
   * @returns {Promise<AbilitazioneConfig>}
   */
  public getRichiestaAbilitazioneConfig(): Promise<AbilitazioneConfig> {
    const loader = 'getRichiestaAbilitazioneConfig';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetRichiestaAbilitazioneConfig`;
    const obs$ = this._http.post<KTResponse<AbilitazioneConfig>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Innesca il processo di richiesta abilitazione, restituendo, se necessario, l'URL al PDF da aprire. \
   * La valorizzazione dei campi è dipendente dalla risposta alla chiamata al metodo getRichiestaAbilitazioneConfig.
   * I campi non richiesti potranno essere lasciati vuoti o null (non verranno comunque considerati se non necessari). \
   * Il servizio può essere chiamato in anonimo. \
   *
   * @see getRichiestaAbilitazioneConfig
   * @param richiestaAbilitazione
   * @returns {Promise<string>}
   */
  public getRichiestaAbilitazione(richiestaAbilitazione: AbilitazioneRequestDTO): Promise<string> {
    const loader = 'getRichiestaAbilitazione';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}RichiestaAbilitazione`;
    const obs$ = this._http
      .post<KTResponse<string>>(
        api,
        {
          richiestaAbilitazione,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce le informazioni di anagrafica dell'utente specificato. \
   * Se userName è null verrà considerato l'utente che ha effettuato la login. \
   * L'utente specificato sarà mostrato solo se il richiedente è il country manager o un amministratore della stessa agenzia.
   *
   * @param userName Utente da richiedere
   * @param preventCache
   * @returns { Promise<UserProfileDTO> }
   */
  public getUserProfile(userName: string = null, preventCache = false): Promise<UserProfileDTO> {
    const loader = 'getUserProfile';
    this._loadingService.startLoading(loader);
    try {
      const data: UserProfileDTO = JSON.parse(sessionStorage.getItem(SessionStorageKey.USER_DATA));
      if (!data || !Object.keys(data)?.length || preventCache) throw null;

      this._loadingService.stopLoading(loader);
      return Promise.resolve(data);
    } catch {
      const api = `${this.CCKBasePath}${this.UserServicesPath}GetUserProfile`;
      const obs$ = this._http
        .post<KTResponse<UserProfileDTO>>(
          api,
          {
            userName,
          },
          this.WithCredentials,
        )
        .pipe(
          this.handleKtApi,
          tap((res) => {
            sessionStorage.setItem(SessionStorageKey.USER_DATA, JSON.stringify(res));
          }),
          finalize(() => {
            this._loadingService.stopLoading(loader);
          }),
        );

      return lastValueFrom(obs$);
    }
  }

  /**
   * Fornisce le informazioni di anagrafica dell'agenzia specificata.
   * Se agencyCode è null sarà considerata l'agenzia che ha effettuato la login.
   * L'agenzia specificata sarà mostrata solo se il richiedente è il country manager o l'agenzia è ad esso correlata.
   *
   * @param agencyCode Codice Agenzia
   * @returns { Promise<AgencyProfileResponseDataDTO> }
   */
  public getAgencyProfile(agencyCode: string = null, preventCache = false): Promise<AgencyProfileResponseDataDTO> {
    const loader = 'getAgencyProfile';
    this._loadingService.startLoading(loader);
    try {
      const data: AgencyProfileResponseDataDTO = JSON.parse(sessionStorage.getItem(SessionStorageKey.AGENCY_DATA_FULL));
      if (!data || !Object.keys(data)?.length || preventCache) throw null;

      this._loadingService.stopLoading(loader);
      return Promise.resolve(data);
    } catch {
      const api = `${this.CCKBasePath}${this.UserServicesPath}GetAgencyProfile`;
      const obs$ = this._http
        .post<KTResponse<AgencyProfileResponseDataDTO>>(
          api,
          {
            agencyCode,
          },
          this.WithCredentials,
        )
        .pipe(
          this.handleKtApi,
          tap((res) => {
            sessionStorage.setItem(SessionStorageKey.AGENCY_DATA_FULL, JSON.stringify(res));
          }),
          finalize(() => {
            this._loadingService.stopLoading(loader);
          }),
        );

      return lastValueFrom(obs$);
    }
  }

  /**
   * Fornisce le informazioni di anagrafica dell'agenzia specificata che tornano dal CRM.
   * Se agencyCode è null sarà considerata l'agenzia che ha effettuato la login.
   * L'agenzia specificata sarà mostrata solo se il richiedente è il country manager o l'agenzia è ad esso correlata.
   *
   * @param agencyCode Codice Agenzia
   * @returns { Promise<CRMAgencyProfileWrapperDTO> }
   */
  public getAgencyProfileExtended(agencyCode: string = null, preventCache = false): Promise<CRMAgencyProfileWrapperDTO> {
    const loader = 'getAgencyProfileExtended';
    this._loadingService.startLoading(loader);
    try {
      const data: CRMAgencyProfileWrapperDTO = JSON.parse(sessionStorage.getItem(SessionStorageKey.AGENCY_DATA_EXT));
      if (!data || !Object.keys(data)?.length || preventCache) throw null;

      this._loadingService.stopLoading(loader);
      return Promise.resolve(data);
    } catch {
      const api = `${this.CCKBasePath}${this.UserServicesPath}GetAgencyProfileFromCRM`;
      const obs$ = this._http
        .post<KTResponse<CRMAgencyProfileWrapperDTO>>(
          api,
          {
            agencyCode,
          },
          this.WithCredentials,
        )
        .pipe(
          this.handleKtApi,
          tap((res) => {
            sessionStorage.setItem(SessionStorageKey.AGENCY_DATA_EXT, JSON.stringify(res));
          }),
          finalize(() => {
            this._loadingService.stopLoading(loader);
          }),
        );

      return lastValueFrom(obs$);
    }
  }

  /**
   * Permette di ottenere l'elenco delle agenzie correlate a quella che ha effettuato la login,
   * purché l'utente corrente sia amministratore di agenzia o di gruppo ed agenzia.
   *
   * @param align
   * @returns {Promise<CorrelatedAgencyDTO[]>}
   */
  public GetCorrelatedAgencies(align = true): Promise<CorrelatedAgencyDTO[]> {
    const loader = 'GetCorrelatedAgencies';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetCorrelatedAgencies`;
    const obs$ = this._http
      .post<KTResponse<CorrelatedAgencyDTO[]>>(
        api,
        {
          align,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di ottenere l'elenco delle agenzie correlate a quella specificata,
   * purché l'utente corrente sia il country manager.
   *
   * @param agencyCode Codice Agenzia
   * @returns {Promise<CorrelatedAgencyDTO[]>}
   */
  public AlignCorrelatedAgencies(agencyCode: string): Promise<CorrelatedAgencyDTO[]> {
    const loader = 'AlignCorrelatedAgencies';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}AlignCorrelatedAgencies`;
    const obs$ = this._http
      .post<KTResponse<CorrelatedAgencyDTO[]>>(
        api,
        {
          agencyCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di impersonare l'agenzia specificata, purché l'utente corrente
   * sia amministratore di agenzia o di gruppo ed agenzia.
   *
   * @param agencyCode Codice Agenzia da impersonare
   * @returns { Promise<null> }
   */
  public ImpersonateAgency(agencyCode: string): Promise<null> {
    const loader = 'ImpersonateAgency';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}ImpersonateAgency`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          agencyCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di interrompere l'azione di impersonare un'agenzia, purché
   * l'utente corrente sia amministratore di agenzia o di gruppo ed agenzia.
   *
   * @returns { Promise<null> }
   */
  public StopImpersonatingAgency(): Promise<null> {
    const loader = 'StopImpersonatingAgency';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}StopImpersonatingAgency`;
    const obs$ = this._http.post<KTResponse<null>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di verificare se si sta impersonando un'agenzia, purché
   * l'utente corrente sia amministratore di agenzia o di gruppo ed agenzia.
   *
   * @returns { Priomise<boolean> }
   */
  public IsImpersonatingAgency(): Promise<boolean> {
    const loader = 'IsImpersonatingAgency';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}IsImpersonatingAgency`;
    const obs$ = this._http.post<KTResponse<boolean>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce le informazioni di fatturato dell'agenzia corrispondenti ai criteri di ricerca.
   *
   * @param From Ricerca da
   * @param To Ricerca a
   * @param ShipCode Codice Nave
   * @returns {Promise<AgencyBalanceDataDTO>}
   */
  public getAgencyBalance(From: Date = new Date(), To: Date = new Date(), ShipCode = ''): Promise<AgencyBalanceDataDTO> {
    const loader = 'getAgencyBalance';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetAgencyBalance`;
    const obs$ = this._http
      .post<KTResponse<AgencyBalanceDataDTO>>(
        api,
        {
          request: {
            From: dayjs(From).format('YYYY-MM-DD'),
            To: dayjs(To).format('YYYY-MM-DD'),
            ShipCode,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce i tipi di assicurazione disponibili.
   * La ricerca viene fatta su TTG se il booking in sessione ha tariffa e passeggeri impostati,
   * altrimenti sarà restituita la lista configurata per mercato.
   * Un valore positivo di guestSequenceNumber serve per ottenere il costo dei tipi di
   * assicurazione relativi ad un singolo passeggero
   *
   * @param guestSequenceNumber
   * @returns {Promise<InsuranceTypeDTO[]>}
   */
  public getInsuranceTypes(guestSequenceNumber = 0): Promise<InsuranceTypeDTO[]> {
    const loader = 'getInsuranceTypes';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetInsuranceTypes`;
    const obs$ = this._http
      .post<KTResponse<InsuranceTypeDTO[]>>(
        api,
        {
          guestSequenceNumber,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Da chiamare per salvare in sessione il contenuto attuale della pagina.
   *
   * @param Booking Booking da salvare
   * @param SourcePage Pagina corrente
   * @param DestinationPage Pagina di destinazione
   * @returns {Promsie<string>}
   */
  public setCurrentBookingToSession(Booking: BookingDataDTO, SourcePage: string, DestinationPage: string): Promise<string> {
    const loader = 'setCurrentBookingToSession';
    this._loadingService.startLoading(loader);
    let headers = new HttpHeaders();
    headers = headers.append(CustomHeaders.TRANSFORM_REQUEST, [TransformerRequestCodes.ADD_FISCOD_FOREIGN_GUEST].join(','));
    headers = headers.append(CustomHeaders.TRANSFORM_RESPONSE, [TransformerResponseCodes.REMOVE_FISCOD_ON_FOREIGN_GUEST].join(','));
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}SetCurrentBookingToSession`;
    const obs$ = this._http
      .post<KTResponse<string>>(
        api,
        {
          request: {
            Booking,
            SourcePage,
            DestinationPage,
          },
        },
        {
          ...this.WithCredentials,
          headers,
        },
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Copia il current booking nel master booking. \
   * Va chiamato per confermare in sessione le
   * modifiche fatte nella pagina (ad esempio quando si conferma la modifica di un preventivo). \
   * E' chiamato in automatico quando si chiama SetCurrentBookingToSession prima di passare ad
   * una nuova pagina (quando cioè SourcePage e DestinationPage sono diversi), oppure quando si
   * effettua una QuickQuotation o si crea o modifica una pratica verso TTG
   *
   * @see setCurrentBookingToSession
   * @returns {Promise<null>}
   */
  public consolidateBooking(): Promise<null> {
    const loader = 'consolidateBooking';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}ConsolidateBooking`;
    const obs$ = this._http.post<KTResponse<null>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce il booking corrente contenuto in sessione. \
   * Se lo stato del booking in sessione non è compatibile con lo stato richiesto per la pagina passata come
   * parametro il metodo restituisce un errore ("Success": false) e il campo "Message" ne contiene i dettagli.
   *
   * @param callingPage Pagina del flusso di booking da richiedere
   * @returns {Promise<BookingDataDTO>}
   */
  public getCurrentBookingFromSession(callingPage: string): Promise<BookingDataDTO> {
    const loader = 'getCurrentBookingFromSession';
    this._loadingService.startLoading(loader);
    let headers = new HttpHeaders();
    headers = headers.append(
      CustomHeaders.TRANSFORM_RESPONSE,
      [TransformerResponseCodes.GUEST_TBA, TransformerResponseCodes.REMOVE_FISCOD_ON_FOREIGN_GUEST].join(','),
    );
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetCurrentBookingFromSession`;
    const obs$ = this._http
      .post<KTResponse<BookingDataDTO>>(
        api,
        {
          callingPage,
        },
        {
          ...this.WithCredentials,
          headers,
        },
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce il booking con cui inizializzare la nuova pagina. \
   * Contestualmente il current booking viene allineato con il contenuto del master. \
   * Se lo stato del booking in sessione non è compatibile con lo stato richiesto per la pagina passata come
   * parametro il metodo restituisce un errore ("Success": false) e il campo "Message" ne contiene i dettagli.
   *
   * @param callingPage Pagina del flusso di booking da richiedere
   * @returns {Promise<BookingDataDTO>}
   */
  public getMasterBookingFromSession(callingPage: string): Promise<BookingDataDTO> {
    const loader = 'getMasterBookingFromSession';
    this._loadingService.startLoading(loader);
    let headers = new HttpHeaders();
    headers = headers.append(
      CustomHeaders.TRANSFORM_RESPONSE,
      [TransformerResponseCodes.GUEST_TBA, TransformerResponseCodes.REMOVE_FISCOD_ON_FOREIGN_GUEST].join(','),
    );
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetMasterBookingFromSession`;
    const obs$ = this._http
      .post<KTResponse<BookingDataDTO>>(
        api,
        {
          callingPage,
        },
        {
          ...this.WithCredentials,
          headers,
        },
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Gestisce l'invio dei dettagli della pratica in formato PDF per email. \
   * Il parametro html contiene il markup da convertire in PDF (viene usato il processo wkHtmlToPdf).
   *
   * @param emailAddress Indirizzo email a cui inviare i dettagli della pratica
   * @param html Html del dettaglio pratica
   * @returns {Promise<null>}
   */
  public sendBookingDetails(emailAddress: string, html: string): Promise<null> {
    const loader = 'sendBookingDetails';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}SendBookingDetails`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          emailAddress,
          html,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Endpoint non più presente
   *
   * @deprecated
   */
  public getAvailableCabinLists(): Promise<unknown> {
    // const loader = 'getAvailableCabinLists';
    // this._loadingService.startLoading(loader);
    // const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAvailableCabinLists`;
    // const obs$ = this._http.post<KTResponse<any>>(api, {}, this.WithCredentials).pipe(this.handleKtApi, finalize(() => {
    //   this._loadingService.stopLoading(loader);
    // }));
    // return lastValueFrom(obs$);
    return Promise.reject("Endpoint doesn't exist");
  }

  /**
   * Fornisce l'elenco dei servizi speciali disponibili per il passeggero e la crociera specificati,
   * oltre alle possibili delivery location relative alla nave.
   *
   * @param guestId Id Utente
   * @param cruiseCode Codice Crociera
   * @returns { Promise<SpecialServiceListDataDTO> }
   */
  public getAvailableSpecialServices(guestId: string, cruiseCode: string): Promise<SpecialServiceListDataDTO> {
    const loader = 'getAvailableSpecialServices';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAvailableSpecialServices`;
    const obs$ = this._http
      .post<KTResponse<SpecialServiceListDataDTO>>(
        api,
        {
          guestId,
          cruiseCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei voucher disponibili per il passeggero specificato.
   *
   * @param guestId
   * @returns {Promise<VoucherDTO[]>}
   */
  public getAvailableVoucher(guestId: string): Promise<VoucherDTO[]> {
    const loader = 'getAvailableVoucher';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAvailableVouchers`;
    const obs$ = this._http
      .post<KTResponse<VoucherDTO[]>>(
        api,
        {
          guestId,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco delle nazionalità gestite (codice, descrizione già localizzata ed indicazione OFAC)
   *
   * @returns {Promise<NationalityDTO[]>}
   */
  public getNationalities(): Promise<NationalityDTO[]> {
    const loader = 'getNationalities';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetNationalities`;
    const obs$ = this._http.post<KTResponse<NationalityDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco dei languages gestiti (codice e descrizione già localizzata).
   *
   * @returns {Promise<LanguageDTO[]>}
   */
  public getLanguages(): Promise<LanguageDTO[]> {
    const loader = 'getLanguages';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetLanguages`;
    const obs$ = this._http.post<KTResponse<LanguageDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco dei Country gestiti (codice e descrizione già localizzata)
   *
   * @returns {Promise<CountryDTO[]>}
   */
  public getCountries(): Promise<CountryDTO[]> {
    const loader = 'getCountries';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetCountries`;
    const obs$ = this._http.post<KTResponse<CountryDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco delle Regions gestite dato un Country code (codice e descrizione già localizzata)
   * o un array vuoto se il country non prevede regions.
   *
   * @param countryCode Codice Country
   * @returns {Promise<RegionDTO[]>}
   */
  public getRegions(countryCode: CountryDTO['Code']): Promise<RegionDTO[]> {
    const loader = 'getRegions';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetRegions`;
    const obs$ = this._http
      .post<KTResponse<RegionDTO[]>>(
        api,
        {
          countryCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco delle Navi a catalogo.
   *
   * @returns {Promise<ShipListItemDTO[]>}
   */
  public getShips(): Promise<ShipListItemDTO[]> {
    const loader = 'getShips';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetShips`;
    const obs$ = this._http.post<KTResponse<ShipListItemDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Ottiene la lista dei documenti per un dato passeggero con le relative informazioni per
   * la costruzione dei form di raccolta dati in BookingQuote e BookingEdit. \
   * Necessita di un booking inizializzato ed il risultato tiene conto della nazionalità del passeggero se già salvata
   * nel booking in sessione (quindi i risultati potrebbero variare se si effettua la chiamata con un passeggero con
   * nazionalità valorizzata o meno). \
   * Al cambio di nazionalità il servizio deve essere chiamato di nuovo.
   *
   * @param guestId Id Passeggero
   * @returns { Promise<DocumentInfoDTO> }
   */
  public getDocumentInfo(guestId: string): Promise<DocumentInfoDTO[]> {
    const loader = 'getDocumentInfo';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetDocumentsInfo`;
    const obs$ = this._http
      .post<KTResponse<DocumentInfoDTO[]>>(
        api,
        {
          guestId,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Ottiene la lista dei documenti per un dato itinerario (solo lista semplice).
   *
   * @param itineraryCode
   * @returns {Promise<SimpleDocumentDTO[]>}
   */
  public getDocumentsList(itineraryCode: string): Promise<SimpleDocumentDTO[]> {
    const loader = 'getDocumentsList';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetDocumentsList`;
    const obs$ = this._http
      .post<KTResponse<SimpleDocumentDTO[]>>(
        api,
        {
          itineraryCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce i biglietti associati al numero di booking corrente.
   *
   * @returns {Promise<TicketDTO[]>}
   */
  public getTickets(): Promise<TicketDTO[]> {
    const loader = 'getTickets';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetTickets`;
    const obs$ = this._http.post<KTResponse<TicketDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'indirizzo della pagina da mostrare per il check-in online.
   *
   * @returns {Promise<string>}
   */
  public getWebCheckInUrl(): Promise<string> {
    const loader = 'getWebCheckInUrl';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetWebCheckInUrl`;
    const obs$ = this._http.post<KTResponse<string>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'indirizzo della pagina da mostrare per gestire il pagamento con WorldPay.
   *
   * *NOTE*: **RICHIEDE** un booking initialization
   *
   * @returns {Promise<string>}
   */
  public getWorldPayUrl(): Promise<string> {
    const loader = 'getWorldPayUrl';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetWorldPayUrl`;
    const obs$ = this._http.post<KTResponse<string>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'indirizzo della pagina da mostrare per gestire il pagamento con WorldPay.
   *
   * *NOTE*: Questa chiamata non necessita di un booking initialization.
   *
   * @returns {Promise<string>}
   */
  public GetWorldPayUrlByCurrencyCode(currencyCode = 'EUR'): Promise<string> {
    const loader = 'GetWorldPayUrlByCurrencyCode';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetWorldPayUrlByCurrencyCode`;
    const obs$ = this._http.post<KTResponse<string>>(api, { currencyCode }, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce per ciascuna cabina del booking l'elenco dei ristoranti disponibili.
   *
   * @param {number} cabinIndex Indice cabina
   * @param {string} restaurantCode Codice ristorante
   * @returns {Promise<RestaurantListsDTO>}
   */
  public getRestaurants(cabinIndex = 0, restaurantCode: string = null): Promise<RestaurantListsDTO> {
    const loader = 'getRestaurants';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetRestaurants`;
    const obs$ = this._http
      .post<KTResponse<RestaurantListsDTO>>(
        api,
        {
          cabinIndex,
          restaurantCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce le quote di servizio per adulti e bambini, nelle valute previste dal booking in sessione.
   *
   * @returns {Promise<ServiceChargeDTO[]>}
   */
  public GetServiceCharges(): Promise<ServiceChargeDTO[]> {
    const loader = 'GetServiceCharges';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetServiceCharges`;
    const obs$ = this._http.post<KTResponse<ServiceChargeDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce il booking corrispondente ai criteri di ricerca impostati, salvandolo già in sessione.
   *
   * @param BookingNumber Numero Booking
   * @param BookingNumberTravelAndFriends Numero Booking Travel&Friends
   * @returns {Promise<BookingDataDTO>}
   */
  public displayBooking(BookingNumber: string, BookingNumberTravelAndFriends: string = undefined): Promise<BookingDataDTO> {
    const loader = 'displayBooking';
    this._loadingService.startLoading(loader);
    let headers = new HttpHeaders();
    headers = headers.append(
      CustomHeaders.TRANSFORM_RESPONSE,
      [TransformerResponseCodes.GUEST_TBA, TransformerResponseCodes.REMOVE_FISCOD_ON_FOREIGN_GUEST].join(','),
    );

    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}DisplayBooking`;
    const obs$ = this._http
      .post<KTResponse<BookingDataDTO>>(
        api,
        {
          filters: {
            BookingNumber,
            BookingNumberTravelAndFriends,
          },
        },
        {
          ...this.WithCredentials,
          headers,
        },
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce un elenco di booking sulla base dei criteri di ricerca impostati.
   *
   * @param LastName Cognome
   * @param BookingNumber Numero Booking
   * @param BookingNumberTravelAndFriends Numero Booking Travel&Friends
   * @param GroupId Id Gruppo
   * @returns {Promise<BookingListItemDTO[]>}
   */
  public displayBookingList(
    LastName = '',
    BookingNumber = '',
    BookingNumberTravelAndFriends = '',
    GroupId = '',
  ): Promise<BookingListItemDTO[]> {
    const loader = 'displayBookingList';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}DisplayBookingList`;
    const obs$ = this._http
      .post<KTResponse<BookingListItemDTO[]>>(
        api,
        {
          filters: {
            LastName,
            BookingNumber,
            BookingNumberTravelAndFriends,
            GroupId,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle ultime n pratiche create da Costaclick
   *
   * @param n Numero di ultimi booking da mostrare
   * @returns {Promise<BookingListItemDTO[]>}
   */
  public getLastBookings(n = 30): Promise<BookingListItemDTO[]> {
    const loader = 'getLastBookings';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetLastBookings`;
    const obs$ = this._http
      .post<KTResponse<BookingListItemDTO[]>>(
        api,
        {
          n,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di modificare le informazioni di anagrafica dell'agenzia specificata (se non è indicato il code verrà
   * aggiornata l'agenzia che ha effettuato la login). \
   * A seconda che si modifichi l'agenzia corrente o meno saranno
   * salvati solo alcuni campi, come accadeva sul vecchio CostaClick (l'anagrafica si modifica solo per l'agenzia
   * corrente). \
   * Al termine del salvataggio viene inviata una email all'indirizzo configurato. \
   * L'agenzia specificata sarà modificata solo se il richiedente è il country manager o l'agenzia è ad esso correlata.
   *
   * @param agency Agenzia
   * @returns {Promise<null>}
   */
  public setAgencyProfile(agency: AgencyProfileDTO): Promise<null> {
    const loader = 'setAgencyProfile';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}SetAgencyProfile`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          agency,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * *FIXME*: Missing description for api
   * @param agency
   * @returns {Promise<null>}
   */
  public setAgencyProfileExtended(agency: CRMAgencyProfileDTO): Promise<null> {
    const loader = 'setAgencyProfileExtended';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}SetAgencyProfileToCRM`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          agency,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di modificare le informazioni di anagrafica dell'utente specificato (se non è indicato
   * lo username verrà aggiornato l'utente che ha effettuato la login). \
   * Al termine del salvataggio viene inviata una email all'indirizzo specificato (solo per modifiche al
   * current user, mentre per il cambio password viene comunque inviata). \
   * L'utente specificato sarà modificato solo se il richiedente è il country manager o un amministratore della stessa agenzia.
   *
   * @param user
   * @returns {Promise<null>}
   */
  public setUserProfile(user: UserProfileDTO): Promise<null> {
    const loader = 'setUserProfile';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}SetUserProfile`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          user,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette all'utente che ha effettuato la login di modificare la propria password
   * e specificare domanda e risposta di sicurezza. \
   * Passando l'agency code si può utilizzare la funzionalità per l'amministratore nel
   * caso di abilitazione agenzia (occorre quindi valorizzare a true uno dei booleani
   * EnablingAgency e ResettingPassword).
   *
   * @param request
   * @returns {Promise<''>}
   */
  public setPassword(request: SetPasswordDTO): Promise<''> {
    const loader = 'changePassword';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}SetPassword`;
    const obs$ = this._http
      .post<KTResponse<''>>(
        api,
        {
          request,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette all'utente che non ha effettuato la login di modificare la propria password
   * specificando token e username ricevuti via email
   *
   * @param request
   * @returns {Promise<''>}
   */
  public forgotPasswordSetPassword(request: ForgotPasswordSetPasswordDTO): Promise<ForgotPasswordSetPasswordResponseDTO> {
    const loader = 'changePassword';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}ForgotPasswordSetPassword`;
    const obs$ = this._http
      .post<KTResponse<ForgotPasswordSetPasswordResponseDTO>>(
        api,
        {
          request,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette all'utente che non ha effettuato la login di modificare la propria password
   * specificando token e username ricevuti via email
   *
   * @param request
   * @returns {Promise<''>}
   */
  public CreateNewToken(request: CreateNewTokenDTO): Promise<ForgotPasswordSetPasswordResponseDTO> {
    const loader = 'changePassword';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}CreateNewToken`;
    const obs$ = this._http
      .post<KTResponse<ForgotPasswordSetPasswordResponseDTO>>(
        api,
        {
          request,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }


  /**
   * Permette all'utente admin o country manager di forzare il reset password per un utente specifico
   *
   * @param request
   * @returns {Promise<''>}
   */
  public forceChangePassword(request: ForceChangePasswordDTO): Promise<''> {
    const loader = 'changePassword';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}ForceChangePassword`;
    const obs$ = this._http
      .post<KTResponse<''>>(
        api,
        {
          request,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di effettuare l'upload del logo dell'agenzia correntemente loggata.
   *
   * @param file
   * @returns {Promise<string>}
   */
  public uploadAgencyLogo(file: File): Promise<string> {
    const loader = 'uploadAgencyLogo';
    this._loadingService.startLoading(loader);
    const formData = new FormData();
    formData.append('file', file);
    const api = `${this.CCKBasePath}${this.UserServicesPath}UploadAgencyLogo`;
    const obs$ = this._http.post<KTResponse<string>>(api, formData, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco delle voci per il menù utente (Header di pagina) in forma di array.
   *
   * @returns {Promise<MenuItemDTO[]>}
   */
  public getUserMenuData(): Promise<MenuItemDTO[]> {
    const loader = 'getUserMenuData';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetUserMenuData`;
    const obs$ = this._http.post<KTResponse<MenuItemDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di creare un nuovo profilo utente specificato \
   * Per il campo sex:
   * * 0 => Maschio
   * * 1 => Femmina
   *
   * @param user
   * @returns {Promise<null>}
   */
  public createUserProfile(user: UserProfileDTO): Promise<null> {
    const loader = 'createUserProfile';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}CreateUserProfile`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          user,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di eliminare il profilo utente specificato. \
   * L'utente specificato sarà eliminato solo se il richiedente è il
   * country manager o un amministratore della stessa agenzia.
   *
   * @param userName
   * @returns { Promise<null> }
   */
  public deleteUserProfile(userName: string): Promise<null> {
    const loader = 'deleteUserProfile';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}DeleteUserProfile`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          userName,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce il numero di telefono di emergenza dell'agenzia che ha effettuato la login.
   *
   * @returns {Promise<string>}
   */
  public getEmergencyPhoneNumber(): Promise<string> {
    const loader = 'getEmergencyPhoneNumber';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetEmergencyPhoneNumber`;
    const obs$ = this._http.post<KTResponse<string>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di impostare il numero di telefono di emergenza dell'agenzia che ha effettuato la login
   * @param number
   * @returns {Promise<null>}
   */
  public setEmergencyPhoneNumber(number: string): Promise<null> {
    const loader = 'setEmergencyPhoneNumber';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}SetEmergencyPhoneNumber`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          number,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di effettuare l'upload della busta paga se richiesto. \
   * **NOTE** \
   * Se la chiamata andrà a buon fine ("Success": true) il nome file presente
   * in Result andrà poi salvato nella proprietà "PaySlipTempFileName" dell'
   * oggetto "BookingDataDTO" prima di effettuate una nuova "SetCurrentBookingToSession".
   *
   * @see setCurrentBookingToSession
   * @param file
   * @returns {Promise<string>}
   */
  public uploadPaySlip(file: File): Promise<string> {
    const loader = 'uploadPaySlip';
    this._loadingService.startLoading(loader);
    const formData = new FormData();
    formData.append('file', file);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}UploadPaySlip`;
    const obs$ = this._http.post<KTResponse<string>>(api, formData, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di ottenere l'url della busta paga caricata.
   *
   * @returns {Promise<string>}
   */
  public getPaySlipUrl(): Promise<string> {
    const loader = 'getPaySlipUrl';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetPaySlipUrl`;
    const obs$ = this._http.post<KTResponse<string>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'indirizzo della pagina da mostrare per il preventivo emozionale.
   * Il metodo lavora sul booking in sessione.
   *
   * @returns {Promise<string>}
   */
  public getDominoUrl(): Promise<string> {
    const loader = 'getDominoUrl';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetDominoUrl`;
    const obs$ = this._http.post<KTResponse<string>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco dei file scaricabili per la sezione (WEB) di contesto. \
   * Il servizio ritorna i file presenti nella folder "Downloads" della lista
   * "Documents" presente nel web di contesto
   *
   * @see DownloadMainCtrl.js:32
   * @param downloadPath
   * @returns
   */
  public getDownloadFileList(downloadPath: string): Promise<any> {
    const loader = 'getDownloadFileList';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${downloadPath}${this.ContentServicesPath}GetDownloadFileList`;
    const obs$ = this._http.post<KTResponse<any>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle ultime n pratiche create da Costaclick
   * @returns {Promise<NewsListDataDTO>}
   */
  public getNews(): Promise<NewsListDataDTO> {
    const loader = 'getNews';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetNews`;
    const obs$ = this._http.post<KTResponse<NewsListDataDTO>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco degli Available languages per la ricerca/generazione dei PDF escursioni
   * se configurati su quel mercato, in caso contrario la lista sarà vuota. \
   * \
   * Se la chiamata torna dati tra questi parametri andrà selezionato il valore per il parametro
   * "pdfLanguages" alla chiamata "GetExcursionPDFList"
   *
   * @see getExcursionPDFList
   * @returns {Promise<ExcursionPDFLanguageDTO[]>}
   */
  public getExcursionPDFAvailableLanguages(): Promise<ExcursionPDFLanguageDTO[]> {
    const loader = 'getExcursionPDFAvailableLanguages';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.ExcursionServicesPath}GetExcursionPDFAvailableLanguages`;
    const obs$ = this._http.post<KTResponse<ExcursionPDFLanguageDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco delle cruise che soddisfano i parametri di ricerca e che hanno
   * un PDF escursioni già generato e disponibile al download.
   *
   * @param dateFrom
   * @param dateTo
   * @param shipCode
   * @param pdfLanguages
   * @returns {Promise<ExcursionPDFItemDTO[]>}
   */
  public getExcursionPDFList(dateFrom: Date, dateTo: Date, shipCode: string, pdfLanguages = ''): Promise<ExcursionPDFItemDTO[]> {
    const loader = 'getExcursionPDFList';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.ExcursionServicesPath}GetExcursionPDFList`;
    const obs$ = this._http
      .post<KTResponse<ExcursionPDFItemDTO[]>>(
        api,
        {
          dateFrom: dayjs(dateFrom).format('YYYY-MM-DD'),
          dateTo: dayjs(dateTo).format('YYYY-MM-DD'),
          shipCode,
          pdfLanguages,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce i dati necessari al Group Tool.
   *
   * @returns {Promise<GroupToolDataDTO>}
   */
  public getGroupToolData(preventCache = false): Promise<GroupToolDataDTO> {
    const loader = 'getGroupToolData';
    this._loadingService.startLoading(loader);
    try {
      const data: GroupToolDataDTO = JSON.parse(sessionStorage.getItem(SessionStorageKey.AGENCY_DATA));
      if (!data || !Object.keys(data)?.length || preventCache) throw null;

      this._loadingService.stopLoading(loader);
      return Promise.resolve(data);
    } catch {
      const api = `${this.CCKBasePath}${this.GenericServicesPath}GetGroupToolData`;
      const obs$ = this._http.post<KTResponse<GroupToolDataDTO>>(api, {}, this.WithCredentials).pipe(
        this.handleKtApi,
        tap((res) => {
          sessionStorage.setItem(SessionStorageKey.AGENCY_DATA, JSON.stringify(res));
        }),
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );

      return lastValueFrom(obs$);
    }
  }

  /**
   * Restituisce l'elenco dei passeggeri che possono prenotare escursioni, relativo al
   * numero di booking specificato, ed il link a cui mandare l'utenete per effettuare per prenotazioni.
   *
   * @param bookingNumber
   * @returns {Promise<ExcursionReservationGuestDTO[]>}
   */
  public GetExcursionReservationGuests(bookingNumber: string): Promise<ExcursionReservationGuestDTO[]> {
    const loader = 'GetExcursionReservationGuests';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.ExcursionServicesPath}GetExcursionReservationGuests`;
    const obs$ = this._http
      .post<KTResponse<ExcursionReservationGuestDTO[]>>(
        api,
        {
          bookingNumber,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di effettuare la generazione di un PDF excusioni per una data cruise on demand. \
   * Restituisce l'url al PDF o un messaggio di errore se non è stato possibile generare il PDF
   *
   * @param departureDate
   * @param cruiseDuration
   * @param shipCode
   * @returns {Promise<string>}
   * @deprecated
   */
  public GeneratePDF(departureDate: Date, cruiseDuration: string, shipCode: string): Promise<string> {
    const loader = 'GeneratePDF';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.ExcursionServicesPath}GeneratePDF`;
    const obs$ = this._http
      .post<KTResponse<string>>(
        api,
        {
          departureDate: dayjs(departureDate).format('YYYY-MM-DD'),
          cruiseDuration,
          shipCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l'elenco delle escursioni associate al codice crociera specificato, raggruppate per porto.
   *
   * @param cruiseCode
   * @returns {Promise<ExcursionListDataDTO>}
   */
  public GetExcursions(cruiseCode: string): Promise<ExcursionListDataDTO> {
    const loader = 'GetExcursions';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.ExcursionServicesPath}GetExcursions`;
    const obs$ = this._http
      .post<KTResponse<ExcursionListDataDTO>>(
        api,
        {
          cruiseCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna la lista dei codici ISO dei country
   *
   * @returns { Promise<CountryISOCodeDTO[]> }
   */
  public GetCountryISOCode(preventCache = false): Promise<CountryISOCodeDTO[]> {
    const loader = 'GetCountryISOCode';
    this._loadingService.startLoading(loader);
    try {
      const data: CountryISOCodeDTO[] = JSON.parse(sessionStorage.getItem(SessionStorageKey.ISO_CODE));
      if (!data || !Object.keys(data)?.length || preventCache) throw null;

      this._loadingService.stopLoading(loader);
      return Promise.resolve(data);
    } catch {
      const api = `${this.CCKBasePath}${this.UserServicesPath}GetCountryISOCode`;
      const obs$ = this._http.post<KTResponse<CountryISOCodeDTO[]>>(api, {}, this.WithCredentials).pipe(
        this.handleKtApi,
        tap((res) => {
          sessionStorage.setItem(SessionStorageKey.ISO_CODE, JSON.stringify(res));
        }),
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
      return lastValueFrom(obs$);
    }
  }

  /**
   * Ritorna una lista di città in base alla ricerca effettuata
   *
   * @param country
   * @param city
   * @returns
   * @see GetCities
   */
  public GetCities(country: string, city: string): Promise<unknown> {
    const loader = 'GetCities';
    this._loadingService.startLoading(loader);
    const api = `https://valuelab.azure-api.net/premiumv2/searchcity`;
    const params = new HttpParams({
      fromObject: {
        suggest: city,
        countryiso: country,
      },
    });
    const obs$ = this._http
      .get<unknown>(api, {
        params,
        headers: this.JakalaLegacyHeaders,
      })
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna una lista di città in base alla ricerca effettuata
   *
   * @param country
   * @param city
   * @returns {Promise<CitySuggestionsData>}
   */
  public GetCitiesLegacy(country: string, city: string): Promise<CitySuggestionsData> {
    const loader = 'GetCitiesLegacy';
    // this._loadingService.startLoading(loader);
    const api = `https://valuelab.azure-api.net/suggestcity`;
    const params = new HttpParams({
      fromObject: {
        country,
        query: city,
      },
    });
    const obs$ = this._http
      .get<CitySuggestionsData>(api, {
        params,
        headers: this.JakalaHeaders,
      })
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   *
   * @param country
   * @param city
   * @param province
   * @returns
   */
  public GetCityInfo(city: string, countryCode?: string, state?: string): Promise<CitySearchResponse> {
    const loader = 'GetCityInfo';
    // this._loadingService.startLoading(loader);
    const api = `https://valuelab.azure-api.net/premiumv2/geocodemunsplit`;
    const params = new HttpParams({
      fromObject: {
        city,
        countryCode,
        state
      },
    });
    const obs$ = this._http
      .get<any>(api, {
        params,
        headers: this.JakalaLegacyHeaders,
      })
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   *
   * @param country
   * @param city
   * @param province
   * @returns
   */
  public GetCityInfoLegacy(country: string, city: string, province: string): Promise<CitySearchResponse> {
    const loader = 'GetCityInfoLegacy';
    // this._loadingService.startLoading(loader);
    const api = `https://valuelab.azure-api.net/searchcity`;
    const params = new HttpParams({
      fromObject: {
        searchtext: city,
        country,
        province,
      },
    });
    const obs$ = this._http
      .get<CitySearchResponse>(api, {
        params,
        headers: this.JakalaHeaders,
      })
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna le informazioni bancarie del Travel Agent
   *
   * @returns {Promise<BankTAInfoResponseDTO>}
   */
  public GetBankTAInfoFetch(): Promise<BankTAInfoResponseDTO> {
    const loader = 'GetBankTAInfoFetch';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetBankTAInfoFetch`;
    const obs$ = this._http.post<KTResponseCustom<BankTAInfoResponseDTO>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithWarningMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna la lista di banche della country data in input
   *
   * @param CountryISOCode
   * @returns {Promise<BankInfoResponseDTO>}
   */
  public GetBankInfoFetch(CountryISOCode = ''): Promise<BankInfoResponseDTO> {
    const loader = 'GetBankInfoFetch';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetBankInfoFetch`;
    const obs$ = this._http
      .post<KTResponseCustom<BankInfoResponseDTO>>(
        api,
        {
          request: {
            BankTAInfo: {
              BankInfo: {
                CountryISOCode,
                BicSwift: '',
              },
            },
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApiWithWarningMessage,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Inserisce i dati della banca del Travel Agent specificato
   *
   * @param BankTAInfo
   * @returns {Promise<null>}
   */
  public SetBankTAInfo(BankTAInfo: BankTAInfoDTO): Promise<null> {
    const loader = 'SetBankTAInfo';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}SetBankTAInfo`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          request: {
            BankTAInfo,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di effettuare l'upload del documento della banca dell'agenzia correntemente loggata
   *
   * @param file
   * @returns {Promise<null>}
   */
  public UploadBankAccount(file: File): Promise<null> {
    const loader = 'UploadBankAccount';
    this._loadingService.startLoading(loader);
    const formData = new FormData();
    formData.append('file', file);
    const api = `${this.CCKBasePath}${this.UserServicesPath}UploadBankAccount`;
    const obs$ = this._http.post<KTResponse<null>>(api, formData, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce un oggetto con I dati generali dell'agenzia con cui si sta operando che
   * vengono visualizzati nella tabella a inizio pagina. \
   * In tale oggetto vengono anche restituiti gli url per il pulsanti "Scarica Piano Commerciale"
   * e "Scarica Lettera di credito" presenti in alto a destra nella pagina. \
   *
   * @returns {Promise<WeCareAgencyData>}
   */
  public GetWeCareAgencyData(): Promise<WeCareAgencyData> {
    const loader = 'GetWeCareAgencyData';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.WeCareServicesPath}GetWeCareAgencyData`;
    const obs$ = this._http.post<KTResponseNoMessage<WeCareAgencyData>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithNoMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Rappresentano i dati per le agenzie che partecipano alla commissione JUMP.
   *
   * @returns {Promise<JumpData[]>}
   */
  public GetJumpData(): Promise<JumpData[]> {
    const loader = 'GetJumpData';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.WeCareServicesPath}GetJumpData`;
    const obs$ = this._http.post<KTResponseNoMessage<JumpData[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithNoMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce i dati visualizzati nel box centrale intitolato "I tuoi obiettivi annuali". \
   * \
   * I dati vengono restituiti in un array diviso per anni, i quali a loro volta sono divisi
   * in array rappresentativi dei semestri (la suddivisione in semestri è stata mantenuta fino
   * all'anno 2015, per gli anni successivi si troverà un unico elemento dell'array
   * rappresentativo di tutto l'anno).
   * \
   * Questa API Torna i dati sul fatturato fino all'anno corrente
   *
   * @returns {Promise<WeCareDataDTO[]>}
   */
  public GetWeCareData(): Promise<WeCareDataDTO[]> {
    const loader = 'GetWeCareData';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.WeCareServicesPath}GetWeCareData`;
    const obs$ = this._http.post<KTResponseNoMessage<WeCareDataDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithNoMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce i dati visualizzati nel box centrale intitolato "I tuoi obiettivi annuali". \
   * \
   * I dati vengono restituiti in un array diviso per anni, i quali a loro volta sono divisi
   * in array rappresentativi dei semestri (la suddivisione in semestri è stata mantenuta fino
   * all'anno 2015, per gli anni successivi si troverà un unico elemento dell'array
   * rappresentativo di tutto l'anno).
   * \
   * Questa API Torna i dati sul fatturato anche per gli anni successivi
   *
   * @returns {Promise<WeCareDataDTO[]>}
   */
  public GetWeCareData_NY(): Promise<WeCareDataDTO[]> {
    const loader = 'GetWeCareData_NY';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.WeCareServicesPath}GetWeCareData_NY`;
    const obs$ = this._http.post<KTResponseNoMessage<WeCareDataDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithNoMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce i dati riguardante all'incentivazione. \
   * I dati vengono restituiti in un array diviso per anni, i quali a loro volta sono
   * divisi in array rappresentativi dei periodi di cui si compone una "Run" seguiC. \
   * I periodi vanno da "P1" a "P6" e sono indicati nel campo "Period"
   *
   * @returns {Promise<SeguiCData[]>}
   */
  public GetSeguiCData(): Promise<SeguiCData[]> {
    const loader = 'GetSeguiCData';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.WeCareServicesPath}GetSeguiCData`;
    const obs$ = this._http.post<KTResponseNoMessage<SeguiCData[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithNoMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * I dati presenti in questo oggetto vengono visualizzati nel popup che si apre cliccando
   * sul pulsante "Dettaglio Pratiche" presente nei grafici dei vari periodi. \
   * Rappresentano il dettaglio delle pratiche che compongono il totale fatturato
   * dall'agenzia nel periodo selezionato.
   *
   * @returns {Promise<ActualDetailData[]>}
   */
  public GetActualData(): Promise<ActualDetailData[]> {
    const loader = 'GetActualData';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.WeCareServicesPath}GetActualData`;
    const obs$ = this._http.post<KTResponseNoMessage<ActualDetailData[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithNoMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna una lista chiave / valore delle navi
   * @param req
   * @returns
   * @see getShips
   * @deprecated
   */
  // public GetShipList(req: any): Promise<unknown> {
  //   return Promise.reject('DEPRECATED API');
  //   const loader = 'GetShipList';
  //   this._loadingService.startLoading(loader);
  //   const api = `${this.CCKBasePath}${this.WeCareServicesPath}GetShipList`;
  //   const obs$ = this._http.post<KTResponseNoMessage<unknown>>(api, {}, this.WithCredentials).pipe(this.handleKtApiWithNoMessage, finalize(() => {
  //   this._loadingService.stopLoading(loader);
  //   }));
  //   return lastValueFrom(obs$);
  // }

  /**
   * Restituisce i dati di sessione necessari per gestire il pagamento con MasterCard.
   *
   * @returns {Promise<CheckOutSessionDTO>}
   */
  public GetMasterCardSession(): Promise<CheckOutSessionDTO> {
    const loader = 'GetMasterCardSession';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetMasterCardSession`;
    const obs$ = this._http.post<KTResponse<CheckOutSessionDTO>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di ottenere la direzione obbligatoria dei trasporti relativi alla
   * crociera e tariffa precedentemente selezionate.
   *
   * @returns
   */
  public GetMandatoryTransportationDirection(): Promise<MandatoryTransportationDirectionDTO[]> {
    const loader = 'GetMandatoryTransportationDirection';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetMandatoryTransportationDirection`;
    const obs$ = this._http.post<KTResponse<MandatoryTransportationDirectionDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Aggiunge un nuovo utente alla loyalty
   *
   * @param req
   * @returns
   * @deprecated Loyalty no more used
   */
  // public InsertB2BLoyaltyUsers(req: any): Promise<any> {
  //   return Promise.reject('DEPRECATED API');
  //   const loader = 'InsertB2BLoyaltyUsers';
  //   this._loadingService.startLoading(loader);
  //   const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}InsertB2BLoyaltyUsers`;
  //   const obs$ = this._http.post<KTResponse<any>>(api, {}, this.WithCredentials).pipe(this.handleKtApiWithWarningMessage, finalize(() => {
  //   this._loadingService.stopLoading(loader);
  //   }));
  //   return lastValueFrom(obs$);
  // }

  /**
   * Torna il programma loyalty
   *
   * @returns { Promise<KTResponseDNoResult & B2BLoyaltyProgramResponse> }
   */
  public GetB2BLoyaltyProgram(): Promise<KTResponseDNoResult & B2BLoyaltyProgramResponse> {
    const loader = 'GetB2BLoyaltyProgram';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetB2BLoyaltyProgram`;
    const obs$ = this._http.post<KTResponseCustom<KTResponseDNoResult & B2BLoyaltyProgramResponse>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithWarningMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Ritorna l'elenco dei Voucher dei clienti paginato e filtrato secondo i parametri di import
   *
   * @param filters
   * @returns {Promise<CustomerVoucherListDTO>}
   */
  public GetCustomerVouchers(filters: CustomerVoucherSearchDTO): Promise<CustomerVoucherListDTO> {
    const loader = 'GetCustomerVouchers';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetCustomerVouchers`;
    const obs$ = this._http
      .post<KTResponse<CustomerVoucherListDTO>>(
        api,
        {
          filters,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApiWithWarningMessage,
        map((resp) => resp.Result),
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Effettua l'export in CSV dll'elenco dei Voucher dei clienti paginato e filtrato secondo i parametri di import.
   *
   * @param filters
   * @returns {Promise<Blob>}
   */
  public ExportCustomerVouchers(filters: CustomerVoucherSearchDTO): Promise<Blob> {
    const loader = 'ExportCustomerVouchers';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}ExportCustomerVouchers`;
    const obs$ = this._http
      .post<any>(
        api,
        {
          filters,
        },
        {
          ...this.WithCredentials,
          responseType: 'arraybuffer' as 'json',
        },
      )
      .pipe(
        this.handleApi,
        map((res) => new Blob([res])),
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco di gruppi relativi all'agenzia che ha effettuato la login.
   *
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public GetGroups(): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'GetGroups';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetGroups`;
    const obs$ = this._http.post<KTResponse<GroupResponseDataDTO>>(api, {}, this.WithCredentials).pipe(
      this.handleApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce le informazioni relative al gruppo richiesto.
   *
   * @param Id
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public GetGroup(Id: string): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'GetGroup';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetGroup`;
    const obs$ = this._http
      .post<KTResponse<GroupResponseDataDTO>>(
        api,
        {
          request: {
            Group: {
              GroupDefinition: {
                Id,
              },
            },
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di richiedere la creazione di un nuovo gruppo con le caratteristiche indicate.
   *
   * @param request
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public CreateGroup(request: GroupRequestDTO): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'CreateGroup';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}CreateGroup`;
    const obs$ = this._http
      .post<KTResponse<GroupResponseDataDTO>>(
        api,
        {
          request,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei tipi di gruppo disponibili.
   *
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public GetGroupTypes(): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'GetGroupTypes';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetGroupTypes`;
    const obs$ = this._http.post<KTResponse<GroupResponseDataDTO>>(api, {}, this.WithCredentials).pipe(
      this.handleApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei termini di pagamento relativi all'agenzia che ha effettuato la login.
   *
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public GetGroupPaymentTerms(): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'GetGroupPaymentTerms';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetGroupPaymentTerms`;
    const obs$ = this._http.post<KTResponse<GroupResponseDataDTO>>(api, {}, this.WithCredentials).pipe(
      this.handleApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei servizi speciali di gruppo associati al codice crociera specificato.
   *
   * @param CruiseCode
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public GetAvailableGroupSpecialServices(CruiseCode: string): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'GetAvailableGroupSpecialServices';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetAvailableGroupSpecialServices`;
    const obs$ = this._http
      .post<KTResponse<GroupResponseDataDTO>>(
        api,
        {
          request: {
            Group: {
              GroupDefinition: {
                CruiseCode,
              },
            },
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco delle condizioni di gruppo relative ai parametri specificati.
   *
   * @param CruiseCode
   * @param GroupPriceType
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public GetGroupConditions(CruiseCode: string, GroupPriceType = 'INC'): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'GetGroupConditions';

    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetGroupConditions`;
    const obs$ = this._http
      .post<KTResponse<GroupResponseDataDTO>>(
        api,
        {
          request: {
            Group: {
              GroupDefinition: {
                CruiseCode,
              },
            },
            GroupPriceType,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
      return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei servizi di bordo disponibili per i gruppi.
   *
   * @param CruiseCode
   * @param GroupPriceType
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public GetGroupOnBoardServices(CruiseCode: string, GroupPriceType = 'INC'): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'GetGroupOnBoardServices';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetGroupOnBoardServices`;
    const obs$ = this._http
      .post<KTResponse<GroupResponseDataDTO>>(
        api,
        {
          request: {
            Group: {
              GroupDefinition: {
                CruiseCode,
              },
            },
            GroupPriceType,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei trasporti di gruppo relativi ai parametri specificati.
   *
   * @param CruiseCode
   * @param Type
   * @param Direction
   * @param Class
   * @param Price
   * @returns {Promise<KTResponse<GroupResponseDataDTO>>}
   */
  public GetGroupTransportations(
    CruiseCode: string,
    Type: string,
    Direction: string,
    Class = 'Y',
    Price = true,
  ): Promise<KTResponse<GroupResponseDataDTO>> {
    const loader = 'GetGroupTransportations';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetGroupTransportations`;
    const obs$ = this._http
      .post<KTResponse<GroupResponseDataDTO>>(
        api,
        {
          request: {
            Group: {
              GroupDefinition: {
                CruiseCode,
              },
              TransportationDetails: {
                Type,
                Direction,
                Class,
              },
            },
            Price,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di salvare su TTG l'informazione relativa al blocco del check-in per la pratica presente in sessione.
   *
   * @param block
   * @returns {Promise<null>}
   */
  public SetWebCheckInAgencyBlock(block: boolean): Promise<KTResponse<null>> {
    const loader = 'SetWebCheckInAgencyBlock';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}SetWebCheckInAgencyBlock`;
    const obs$ = this._http
      .post<KTResponse<null>>(
        api,
        {
          block,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di creare una richiesta di finanziamento.
   *
   * @param Data
   * @returns {Promise<MortgageDataDTO>}
   */
  public AddMortgageRequest(Data: MortgageDataDTO): Promise<MortgageDataDTO> {
    const loader = 'AddMortgageRequest';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}AddMortgageRequest`;
    const obs$ = this._http
      .post<KTResponse<MortgageDataDTO>>(
        api,
        {
          request: {
            Data,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApiWithBlockingMessage,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di modificare la richiesta di finanziamento individuata da uno specifico RequestID.
   *
   * @param Data
   * @returns {Promise<MortgageDataDTO>}
   */
  public UpdateMortgageRequest(Data: MortgageDataDTO): Promise<MortgageDataDTO> {
    const loader = 'UpdateMortgageRequest';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}UpdateMortgageRequest`;
    const obs$ = this._http
      .post<KTResponse<MortgageDataDTO>>(
        api,
        {
          request: {
            Data,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApiWithBlockingMessage,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di reperire i dati della richiesta di finanziamento individuata da uno specifico
   * RequestID per fare una modifica. \
   * E' possibile modificare la richiesta solo una volta: dopo aver chiamato il metodo
   * UpdateMortgateRequest, il presente metodo non restituirà più i valori corrispondenti.
   *
   * @param Data
   * @returns {Promise<MortgageDataDTO>}
   */
  public GetMortgageRequestForUpdate(Data: MortgageDataDTO): Promise<MortgageDataDTO> {
    const loader = 'GetMortgageRequestForUpdate';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.GenericServicesPath}GetMortgageRequestForUpdate`;
    const obs$ = this._http
      .post<KTResponse<MortgageDataDTO>>(
        api,
        {
          request: {
            Data,
          },
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApiWithBlockingMessage,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di conoscere lo stato di abilitazione della funzionalità di
   * override dei valori di KPI, in base ad una configurazione di backend comune
   * a tutti i mercati. \
   * \
   * **SOLO** il Country Manager può invocare questo metodo.
   *
   * @returns {Promise<boolean>}
   */
  public IsKPIOverrideEnabled(): Promise<boolean> {
    const loader = 'IsKPIOverrideEnabled';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}IsKPIOverrideEnabled`;
    const obs$ = this._http.post<KTResponse<boolean>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApiWithBlockingMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Permette di effettuare l'upload del file con l'override dei valori di KPI. \
   * \
   * **Solo** il Country Manager può invocare questo metodo.
   *
   * @param file
   * @returns {Promise<any>}
   */
  public UploadKPIOverride(file: File): Promise<null> {
    const loader = 'UploadKPIOverride';
    this._loadingService.startLoading(loader);
    const formData = new FormData();
    formData.append('file', file, 'KPIFile.csv');
    const api = `${this.CCKBasePath}${this.UserServicesPath}UploadKPIOverride`;
    const obs$ = this._http.post<KTResponse<null>>(api, formData, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce gli AutoItem associati agli sconti relativi ai codici crociera
   * specificati, in base ad una data occupancy.
   *
   * @param cruiseCodes
   * @param occupancyCode
   * @returns {Promise<AutoItemsCruiseListDataDTO>}
   */
  public GetCruiseDiscountAutoItems(cruiseCodes: string[], occupancyCode: string): Promise<AutoItemsCruiseListDataDTO> {
    const loader = 'GetCruiseDiscountAutoItems';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetCruiseDiscountAutoItems`;
    const obs$ = this._http
      .post<KTResponse<AutoItemsCruiseListDataDTO>>(
        api,
        {
          cruiseCodes,
          occupancyCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce il precalcolo della variazione punti CostaClub corrispondente ai valori di input.
   *
   * @param {PreCalculationScoreRequestDTO} request
   * @returns {Promise<PreCalculationScoreDTO>}
   */
  public GetPreCalculationScore(request: PreCalculationScoreRequestDTO): Promise<KTResponse<PreCalculationScoreDTO>> {
    const loader = 'GetPreCalculationScore';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetPreCalculationScore`;
    const obs$ = this._http
      .post<KTResponse<PreCalculationScoreDTO>>(
        api,
        {
          request,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Restituisce i prezzi del set di crociere passate in input
   *
   * @param cruiseCodes
   * @param occupancyCode
   * @returns {Promise<KTResponseCustom<FarePricesCruiseListDataDTO>>}
   */
  public GetCruisesPrices(cruiseCodes: string[], occupancyCode: string): Promise<KTResponseCustom<FarePricesCruiseListDataDTO>> {
    const loader = 'GetCruisesPrices';
    this._loadingService.startLoading(loader);
    //!NO RESPONSE
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}GetCruisesPrices`;
    const obs$ = this._http
      .post<KTResponseCustom<FarePricesCruiseListDataDTO>>(
        api,
        {
          cruiseCodes,
          occupancyCode,
        },
        this.WithCredentials,
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Handler http da chiamare in modalità **GET** per scaricare il file
   * corrispondente al GUID passato in query string.
   *
   * @param guid
   * @returns {Promise<any>}
   * @deprecated Questa api non funziona come dovrebbe **NON** utilizzare!
   */
  public ShorexInvoiceDownload(guid: string): Promise<Blob> {
    const loader = 'ShorexInvoiceDownload';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath.split('/CostaClick')[0]}${this.HandlersPath}InvoiceDownload.ashx`;
    const obs$ = this._http
      .post<Blob>(
        api,
        {},
        {
          ...this.WithCredentials,
          params: new HttpParams({
            fromObject: {
              guid,
            },
          }),
        },
      )
      .pipe(
        this.handleApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
    return lastValueFrom(obs$);
  }

  /**
   * Fornisce l'elenco dei file di fatturazione scaricati per l'agenzia che ha effettuato la login
   *
   * @returns {Promise<AgentInvoiceDownloadDTO[]>}
   */
  public GetAgentInvoiceDownloadList(): Promise<AgentInvoiceDownloadDTO[]> {
    const loader = 'GetAgentInvoiceDownloadList';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.UserServicesPath}GetAgentInvoiceDownloadList`;
    const obs$ = this._http.post<KTResponse<AgentInvoiceDownloadDTO[]>>(api, {}, this.WithCredentials).pipe(
      this.handleKtApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );
    return lastValueFrom(obs$);
  }

  /**
   * Usato per fornire l’elenco (o anche solo il numero) dei FollowUpBooking.
   * Fornisce un elenco di booking filtrati per range di date e per stato:
   * * BKD (booked)
   * * OPT (in scadenza)
   * * CXL (cancellato)
   *
   *  Se non si passa il parametro Status, vengono considerati tutti gli stati
   *
   * @param { 'BKD' | 'OPT' | 'CXL' | ''} Status;
   * @param preventCache
   * @returns { KTResponse<BookingListByAgencyDTO> }
   */
  public BookingListByAgency(Status: 'BKD' | 'OPT' | 'CXL' | '' = '', preventCache = false): Promise<BookingListByAgencyDTO> {
    const loader = 'BookingListByAgency';
    this._loadingService.startLoading(loader);

    let data: BookingListByAgencyDTO = null;
    let key = '';
    switch (Status) {
      case 'OPT':
        key = SessionStorageKey.BOOKING_LIST_BY_ADV_OPT;
        break;
      case 'BKD':
        key = SessionStorageKey.BOOKING_LIST_BY_ADV_BKD;
        break;
      default:
        key = SessionStorageKey.BOOKING_LIST_BY_ADV;
    }

    try {
      data = JSON.parse(sessionStorage.getItem(key));
      if (!data || !Object.keys(data)?.length || preventCache) throw null;
      this._loadingService.stopLoading(loader);
      return Promise.resolve(data);
    } catch {
      const req = {
        request: {
          Booking: {
            Status,
          },
          MaxBooking: '',
          OnlyCount: 'false',
        },
      };
      const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}BookingListByAgency`;
      const obs$ = this._http.post<KTResponse<BookingListByAgencyDTO>>(api, req, this.WithCredentials).pipe(
        this.handleKtApi,
        tap((res) => {
          sessionStorage.setItem(key, JSON.stringify(res));
        }),
        finalize(() => {
          this._loadingService.stopLoading(loader);
        }),
      );
      return lastValueFrom(obs$);
    }
  }

  /**
   * Permette di autenticare l'utente alle promozioni Square definite nel token JWT. \
   * Restituisce il link alla piattaforma Square, verso cui il FrontEnd farà redirect. \
   * In caso l’utente non è ancora registrato, verrà restituito “Success”: false, senza l’url di redirect.
   *
   * @returns { Promise<KTResponse<''>> }
   */
  public EpipoliConnect() {
    const loader = 'EpipoliConnect';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.EpipoliServicesPath}Connect`;
    const req = {};
    const obs$ = this._http.post<KTResponse<''>>(api, req, this.WithCredentials).pipe(
      this.handleApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }

  /**
   * Registra l’utente attualmente loggato in CostaClick per l’abilitazione ad Epipoli. \
   * In caso l’utente è già registrato verrà restituito nel json di risposta il parametro Success con valore false
   *
   * @returns { Promise<KTResponse<null>> }
   */
  public EpipoliRegister() {
    const loader = 'EpipoliRegister';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.EpipoliServicesPath}Register`;
    const req = {};
    const obs$ = this._http.post<KTResponse<null>>(api, req, this.WithCredentials).pipe(
      this.handleApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }

  /**
   * Restituisce l’elenco sia di ricariche già effettuate (crociere già partite),
   * sia di ricariche previste (crociere che ancora devono partire). \
   * La distinzione tra i due casi viene fatta dal campo booleano Recharged.
   *
   * @returns { Promise<KTResponse<RechargeDTO[]>> }
   */
  public EpipoliGetRecharges() {
    const loader = 'EpipoliGetRecharges';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.EpipoliServicesPath}GetRecharges`;
    const req = {};
    const obs$ = this._http.post<KTResponse<RechargeDTO[]>>(api, req, this.WithCredentials).pipe(
      this.handleApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }

  /**
   * Restituisce il valore del wallet direttamente da epipoli (non dalle tabelle del database di CostaClick). \
   * In caso l’utente non è già registrato su epipoli, verrà restituito nel json di risposta “Success”: false
   *
   * @returns { Promise<KTResponse<WalletDTO>> }
   */
  public EpipoliGetWallet() {
    const loader = 'EpipoliGetWallet';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.EpipoliServicesPath}GetWallet`;
    const req = {};
    const obs$ = this._http.post<KTResponse<WalletDTO>>(api, req, this.WithCredentials).pipe(
      this.handleApi,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }

  /**
   * Inserisce un pagamento (parziale o totale) su un booking di gruppo
   *
   * @returns { Promise<null> }
   */
  public SetPayment(params: SetPaymentRequestParams) {
    const loader = 'SetPayment';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}/SetPayment`;
    const obs$ = this._http.post<KTResponse<null>>(api, {
      ...params,
      formOfPayment: 'CreditCard',
      paymentDate: dayjs().format('YYYY-MM-DD'),
    }, this.WithCredentials).pipe(
      this.handleKtApiWithBlockingMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }
  /**
   * Inserisce un pagamento sul booking dlla cifra specificata
   *
   * @returns { Promise<SetPaymentExtendedResponse> }
   */
  public SetPaymentExtended(params: SetPaymentExtendedRequestParams) {
    const loader = 'SetPaymentExtended';
    this._loadingService.startLoading(loader);
    const api = `${this.CCKBasePath}${this.BookingFlowServicesPath}/SetPaymentExtended`;
    const obs$ = this._http.post<KTResponse<SetPaymentExtendedResponse>>(api, {
      request: {
        ...params,
        PaymentDetail: {
          ...params.PaymentDetail,
          FormOfPayment: 'CreditCard',
          PaymentDate: dayjs().format('YYYY-MM-DD'),
        },
      }
    }, this.WithCredentials).pipe(
      this.handleKtApiWithBlockingMessage,
      finalize(() => {
        this._loadingService.stopLoading(loader);
      }),
    );

    return lastValueFrom(obs$);
  }

  /**
   * Invia una richiesta di reset password via mail
   *
   * @returns { Promise<string> }
   */
  public ForgotPasswordSendMail(request: ForgotPasswordSendMailDTO): Promise<string> {
    const loader = 'ForgotPasswordSendMail';
    this._loadingService.startLoading(loader);

    const api = `${this.CCKBasePath}${this.UserServicesPath}ForgotPasswordSendMail`;

    const obs$ = this._http
      .post<KTResponse<string>>(
        api,
        { request },
        this.WithCredentials
      )
      .pipe(
        this.handleKtApi,
        finalize(() => {
          this._loadingService.stopLoading(loader);
        })
      );

    return lastValueFrom(obs$);
  }
}
